// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-11T19:12:59.017Z
// Property: Blue Haven (ID: 6767906449167728)
// Collections: 96 amenities, 10 floorplans (live), 42 photos, 75 POIs, 5 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167728",
  "property_external_id": "fbh8k5r",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/maa-hyde-park-tampa-fl/fbh8k5r/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "blue-haven",
  "property_name": "Blue Haven",
  "property_website_url": "http://blue-haven-theme-demo.multiscreensite.com",
  "property_domain": null,
  "property_address": "502 S Fremont Ave",
  "property_full_address": "502 S Fremont Ave, Tampa, FL 33606",
  "property_address_1": "500 Fremont Rd",
  "property_address_2": null,
  "property_address_city": "Tampa",
  "property_address_state": "FL",
  "property_address_zip_full": null,
  "property_address_zip": "33606",
  "property_address_country": "US",
  "property_address_county": "Hillsborough County",
  "property_neighborhood_address": "Hyde Park",
  "property_address_latitude": "27.9400609",
  "property_address_longitude": "-82.4776448",
  "property_email": null,
  "property_phone": "1234567890",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Tour your way at MAA Hyde Park.</strong> Explore one-, two-, and three-bedroom apartments with standout finishes, spacious screened-in porches, two shimmering pools, a 24-hour fitness center, and pet-friendly spaces—then schedule the tour that fits your day.</p>",
  "property_long_description": "<p><strong>Hyde Park convenience, resort-style ease.</strong> Blue Haven places you in one of Tampa’s most walkable pockets, near Hyde Park Village’s boutiques, cafés, and restaurants, the South Howard dining corridor, Bayshore Boulevard’s waterfront path, and quick routes to Downtown Tampa, the Riverwalk, Water Street, and Armature Works. It’s a connected home base with neighborhood charm and city energy close by.</p><p>Choose from one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with thoughtful details such as smart home technology, walk-in closets, in-home laundry options, screened porches, sunrooms, built-in desks, and upgraded kitchens with stainless steel appliances, granite or quartz countertops, and modern cabinetry in select homes. Around the community, <a href=\"/amenities\">two swimming pools</a>, a 24-hour fitness center, business center, gated access, EV charging, car care center, grilling areas, courtyards, storage options, and pet-friendly spaces bring everyday convenience into sharper focus.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-8db5-7267-904d-7b08f36dc197.webp",
  "property_featured_image_media": {
    "alt_text": "Rooftop pool with lounge chairs and city skyline in the background",
    "public_id": "01a03539-8db5-7267-904d-7b08f36dc197",
    "storage_key": "property/6767906449167728/01a03539-8db5-7267-904d-7b08f36dc197.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "474",
  "property_year_built": "1994",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.61603375527426",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": null,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "No specific details on types of pets allowed, weight limits, maximum number of pets, or monthly pet rent are provided.",
  "property_pet_policy_description": "We offer pet‑friendly studio to 3‑bedroom apartments in Tampa with a dog park on site. (No specific details on types of pets allowed, weight limits, maximum number of pets, or monthly pet rent are provided.)",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-8c0f-72be-909b-14378c95083a.webp",
  "property_primary_logo_media": {
    "alt_text": "Blue Haven property logo",
    "public_id": "01a03539-8c0f-72be-909b-14378c95083a",
    "storage_key": "property/6767906449167728/01a03539-8c0f-72be-909b-14378c95083a.webp",
    "width": 1550,
    "height": 196
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-1ede-712b-b828-9ba3615af3b4.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0353a-1ede-712b-b828-9ba3615af3b4",
    "storage_key": "property/6767906449167728/01a0353a-1ede-712b-b828-9ba3615af3b4.webp",
    "width": 372,
    "height": 47
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-071c-76cb-ad41-caa17c6cd79b.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0353a-071c-76cb-ad41-caa17c6cd79b",
    "storage_key": "property/6767906449167728/01a0353a-071c-76cb-ad41-caa17c6cd79b.webp",
    "width": 372,
    "height": 47
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#414190",
  "property_secondary_color": "#e9e4dd",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "576 - 13,841,389 sq ft",
  "property_sqft_min": "576",
  "property_sqft_max": "13,841,389",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 35,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJm9rYEWPDwogRfxAg25rO6Nw",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Blue Haven",
  "property_home_romance_title": "Love Where You Live: Your Dream Home Awaits",
  "property_home_amenities_blurb": "<p><strong>Amenities made for easy momentum.</strong> At Blue Haven in Hyde Park, recharge with a 24-hour fitness center, two swimming pools, a spa, and courtyard grilling areas. Everyday details add convenience, from gated access and EV charging to a self car wash, detached garages, storage, recycling, and on-site service. Inside select homes, find quartz or granite countertops, stainless steel appliances, smart home features, walk-in closets, screened porches, sunrooms, and washer/dryer options.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Blue Haven in Hyde Park offers one-, two-, and three-bedroom apartments with open living space, smart storage, and select upgraded finishes like stainless steel appliances, quartz or granite countertops, walk-in closets, built-in desks, high ceilings, screened porches, sunrooms, double vanities, and washer/dryer options—all near community perks including a pool, fitness center, gated access, and pet-friendly outdoor spaces.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview Blue Haven in Hyde Park.</strong> Step inside bright kitchens with stainless steel appliances, airy living spaces, and select homes with high ceilings, built-ins, plank-style flooring, screened porches, sunrooms, double vanities, or desk nooks. Then picture the community beyond: a sparkling pool, shaded courtyards, grill and picnic areas, clubhouse, and fitness center—all captured in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Hyde Park flavor, Tampa access.</strong> From Blue Haven, brick-lined blocks lead to café patios, boutiques, Hyde Park Village favorites, and South Howard’s Restaurant Row energy. Bayshore Boulevard adds bay views and skyline-worthy strolls, while Kennedy Boulevard, Downtown Tampa, the University of Tampa, and HART connections keep the wider city within easy reach. Explore the map, then schedule a closer look.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents call out the details that matter.</strong> Reviews for Blue Haven often highlight responsive service, clear communication, and quick maintenance that keeps apartment living running smoothly. Christopher earns frequent praise for being kind, efficient, and professional, while the front office, clean community spaces, and year-round pool upkeep also stand out. Read more to see what residents appreciate most about Blue Haven.</p>",
  "property_neighborhood_blurb": "<p><strong>Step out into Hyde Park’s Tampa rhythm.</strong> From Blue Haven, your map opens to brick-lined blocks, café patios, boutiques, and the polished open-air energy of Hyde Park Village, where Buddy Brew, Forbici, On Swann, bartaco, and The Fresh Market make everyday errands feel like a stop worth savoring. South Howard brings the neighborhood’s Restaurant Row buzz—think Bern’s Steak House, Haven, Daily Eats, and late-evening options—while Bayshore Boulevard gives you a scenic waterfront route for fresh air, bay views, and skyline moments.</p><p>Close to Kennedy Boulevard, Downtown Tampa, the University of Tampa, and HART bus connections, this Hyde Park location keeps city access simple without losing its oak-shaded, residential feel. Explore nearby favorites on the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Blue Haven fits the area.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep up with real life.</strong> At Blue Haven in Hyde Park, your day can move from a workout in the 24-hour fitness center to a swim at one of two pools, a reset in the spa, or an easy evening around the courtyard grills. Practical extras make a difference, too, with gated access, EV charging, a self car wash, detached garage options, storage, recycling, and on-site management and maintenance.</p><p>Inside, select homes add the finishes you want to see every day: quartz or granite countertops, stainless steel appliances, smart home technology, built-in desks, high ceilings, walk-in closets, screened porches, sunrooms, and washer/dryer options. Pets can enjoy the play area, and you can compare layouts on the <a href=\"/floor-plans\">floor plans</a> page or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make your move?</strong> Choose a one-, two-, or three-bedroom apartment with standout finishes, then enjoy everyday perks like two shimmering pools, a 24-hour fitness center, and an on-site dog park. Start your online application today and take the next step toward home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the Blue Haven leasing team for help finding your next home, choosing the tour option that fits your schedule, or learning more about available one-, two-, and three-bedroom apartments in Tampa.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at Blue Haven?</strong> Start here for quick answers about the community, leasing options, tours, and everyday living. Explore what to expect, then reach out to the leasing team anytime—we’re happy to help you find the right fit.</p>",
  "property_floorplans_blurb": "<p><strong>Find the space that feels right from the start.</strong> At Blue Haven in Hyde Park, your floor plan choices range from efficient one-bedroom apartments to roomier two-bedroom layouts and expansive three-bedroom residences, so you can compare the balance of bedrooms, baths, storage, and open living space that works best for your day-to-day rhythm.</p><p>As you browse current availability, look for select homes with upgraded kitchens, stainless steel appliances, quartz or granite countertops, walk-in closets, built-in desks, high ceilings, screened porches, sunrooms, double vanities, and washer/dryer options. Pair the layout you love with community comforts like the pool, fitness center, gated access, and pet-friendly outdoor spaces on the <a href=\"/amenities\">amenities</a> page, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plans in person.</p>",
  "property_gallery_blurb": "<p><strong>See Blue Haven from every angle.</strong> Start in sunlit kitchens with sleek counters and stainless steel appliances, then move through open living spaces framed by high ceilings, built-ins, and warm plank-style flooring in select homes. Look for the details that make each layout feel distinct: a screened porch ready for fresh air, a bright sunroom, a double vanity, or a quiet desk nook.</p><p>Beyond your front door, the gallery captures the calm rhythm of Hyde Park living: sparkling pool scenes, shaded courtyards, grill and picnic areas, a polished clubhouse, and the fitness center that anchors the <a href=\"/amenities\">community amenities</a>. Browse the photos, explore the <a href=\"/virtual-tours\">virtual tours</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the spaces feel in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore what’s nearby.</strong> Use the interactive map to find available apartments and see how minutes-away dining, retail, and easy access to Selmon Expy. and I-275 connect you to the rest of Tampa.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, rinse, and relax.</strong> At Blue Haven, pet-friendly living goes beyond the apartment door with an on-site dog park, pet play area, and pet wash station that make daily care easier after a walk or play break. No breed restrictions help keep the policy straightforward, while gated access, courtyards, picnic spaces, and outdoor grill areas give your routine more ways to move outside.</p><p>Choose from studio to three-bedroom layouts, including select homes with screened porches, sunrooms, walk-in closets, and in-home laundry options that add comfort around the edges of pet life. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Blue Haven fits your everyday rhythm in Hyde Park.</p>",
  "property_referafriend_blurb": "<p><strong>Love where you live?</strong> Share the spacious layouts, screened-in porches, two shimmering pools, 24-hour fitness center, and dog park that make life here easy to enjoy. Invite a friend to find their next home at Blue Haven today.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access</strong><br>Manage everyday details with ease. Log in to pay rent, submit maintenance requests, and keep your account current—then get back to enjoying life at MAA Hyde Park, from the 24-hour fitness center to the shimmering swimming pools and on-site dog park.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback from life at Blue Haven.</strong> As you browse the reviews, you’ll notice residents consistently highlight responsive service, clear communication, and a maintenance team that helps make everyday apartment living feel easier.</p><p>Christopher is mentioned again and again for being “kind, efficient, and professional,” with residents appreciating quick fixes, helpful tips, and a friendly approach. Reviewers also point to attentive front office staff, clean surroundings, and a pool that looks great year-round. Read the latest ratings below to see what residents value most about calling Blue Haven home.</p>",
  "property_created_at": "1787599323109",
  "property_scheduletour_blurb": "<p><strong>Tour your way.</strong> Get a closer look with a virtual, self-guided, or agent-guided tour. See select apartment finishes, screened-in porches, two shimmering pools, the 24-hour fitness center, and pet-friendly spaces in person—then picture your next home here.</p>",
  "property_thankyou_blurb": "<p><strong>Thanks—we received your inquiry!</strong> A member of our leasing team will follow up soon. In the meantime, explore life at MAA Hyde Park, where flexible tour options, stylish apartment finishes, two shimmering pools, a 24-hour fitness center, and pet-friendly spaces help make home feel easy.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Blue Haven’s virtual tours let you move through the spaces that matter most, from the Fitness Center to the 1BRF, 1BA and 2BR, 2BA apartment tours. Look closely at room flow, natural light, finish details, storage opportunities, and how each layout connects living, dining, and everyday routines.</p><p>Start in the fitness center to preview cardio and strength zones, mirrors, free weights, and the bright, open feel of the workout space. Then compare the apartment walkthroughs at your own pace, pausing where you want a better look. When you’re ready, explore current <a href=\"/floor-plans\">floor plan options</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Blue Haven in Hyde Park in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Blue Haven",
  "property_seo_title_home": "Blue Haven |  Apartments in Tampa, FL",
  "property_seo_description_home": "Experience effortless living at Blue Haven in Tampa, FL! Enjoy stylish floor plans, upscale amenities, and a vibrant community. Make it yours today!",
  "property_seo_title_floorplans": "Floor Plans | Tampa, FL Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Blue Haven in Tampa, FL! Choose from stylish one, two, or three-bedroom floor plans tailored to your lifestyle. Visit today!",
  "property_seo_title_amenities": "Amenities | Tampa, FL Apartments for Rent",
  "property_seo_description_amenities": "Experience the ultimate lifestyle at Blue Haven in Tampa, FL. Enjoy top-notch amenities, beautiful floor plans, and a vibrant community—all just a step away!",
  "property_seo_title_gallery": "Gallery | Apartments in Tampa, FL",
  "property_seo_description_gallery": "Experience the vibrant lifestyle at Blue Haven in Tampa, FL—stunning apartments, top-tier amenities, and a welcoming community await you!",
  "property_seo_title_virtualtours": "Virtual Tours | Blue Haven Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Blue Haven in Tampa, FL! Check out our virtual tour to explore stunning one, two, and three-bedroom apartments for rent.",
  "property_seo_title_interactivemap": "Interactive Map | Blue Haven Apartments",
  "property_seo_description_interactivemap": "Find your serene escape at Blue Haven in Tampa, FL. Use our interactive map to explore spacious one to three-bedroom apartments with stunning amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tampa, FL",
  "property_seo_description_neighborhood": "Unwind at Blue Haven in Tampa, FL! Discover nearby local favorites and explore vibrant neighborhoods. Your ideal lifestyle awaits right outside your door!",
  "property_seo_title_contact": "Contact Us | Blue Haven",
  "property_seo_description_contact": "Reach out to Blue Haven in Tampa, FL, for inquiries about our spacious one, two, and three-bedroom apartments. Your ideal home awaits—connect with us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tampa, FL",
  "property_seo_description_faqs": "Get answers to your questions about Blue Haven in Tampa, FL! From amenities to community perks, our FAQs have you covered. Explore more today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tampa, FL",
  "property_seo_description_reviews": "Join the Blue Haven community in Tampa, FL! See what residents love about our spacious apartments and top-notch amenities. Your next home awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tampa, FL",
  "property_seo_description_applynow": "Experience luxury living at Blue Haven in Tampa! Choose from stylish one, two, or three-bedroom apartments with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Blue Haven",
  "property_seo_description_residentaccess": "Log in to Blue Haven's resident portal in Tampa, FL. Manage rent payments, request maintenance, and enjoy seamless living at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Blue Haven",
  "property_seo_description_referafriend": "Refer a friend to Blue Haven in Tampa, FL! Enjoy vibrant living and fantastic amenities with great friends as neighbors. Your community awaits!",
  "property_seo_title_scheduletour": "Schedule a Tour | Blue Haven",
  "property_seo_description_scheduletour": "Experience serene living at Blue Haven in Tampa, FL. Schedule your tour today and find your perfect home in our vibrant community surrounded by nature!",
  "property_seo_title_privacy": "Privacy Policy | Blue Haven",
  "property_seo_description_privacy": "At Blue Haven, Tampa, your peace of mind matters. Read our privacy policy to see how we protect your information. Your trust is our priority.",
  "property_seo_title_accessibility": "Website Accessibility | Blue Haven",
  "property_seo_description_accessibility": "At Blue Haven in Tampa, we prioritize digital inclusion for all. Our accessibility statement ensures everyone can enjoy our vibrant community. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Blue Haven",
  "property_seo_description_sitemap": "Navigate your way through Blue Haven in Tampa, FL! Our sitemap makes finding your new home easy. Discover amenities, layouts, and local attractions today!",
  "property_seo_title_thankyou": "Thank You | Blue Haven",
  "property_seo_description_thankyou": "Thank you for reaching out to Blue Haven! Your inquiry is in good hands—our team will be in touch soon to help you find your perfect Tampa home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tampa, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787599832342",
  "amenities": [
    {
      "id": "ec_0d79bd92618ad6d7d35ca625",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85b976827d1fd429b7916d84",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_297355eba0281ecb96804c48",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_513b11ce6a1179926093eccc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Wash Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2070238ac74b391a231fdef",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Furnished Units Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13249ae597af0590e57a73e9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aace73dfdae312ea60ad8412",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba3af1eb94b040d134d52472",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24850c5191d8ebcc93b9fd36",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8a232846bb70297d016db16",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34b9f8324d4787d437708dfb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b98c73244af09975843b8ba6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Corporate Suites",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0e0e2e933948911dae65bd2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_298d62c3ce8ffc9824415fde",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9aeb8a978fa881157013f681",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce89c3f8677b5f5ee39232ce",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_711fda474fdcd99a54d3c5af",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e19ba6ad994575eb9cb47738",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0252a2e9e05d4e82c045160",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c9c4ccedb42dee35591f4fc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfab9d31c1d25b8c4691c41f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Additional Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a2b057ea1df5b9c292f8a03",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Bathroom Upgrades",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2ca2a3dd196cb7baaad13ff",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Built Ins",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6189c908ef2c86124ff77aad",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Built-In Desk",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ca8c7629239ed648aa3f33d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Care Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_573b367f4ba45a072b2861c8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Close To Parks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_305019ac87dd64cabbf5d0fe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled-Access Entry Gate",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_245419d5b87e7da0078d6de2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Detached Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23c8d3f8a8aac432b5b9375d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Vanity",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebacd2b7a21cd6da1af4ff31",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Ev Car Charging",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a672951ba2fa4f3ecfb03ea6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5bf0f0335202d2782997e8f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Fully-Equipped 24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6b2035413d4b81f49ac7ee9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Garden Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4186b1ff552ffb43123c954",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c716157a6f4b9c8f8217a1d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83cdf99028afca1cf2eb4b35",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ec59b96adb2e605fff8100f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen Upgrades",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d660f73d45dc9375284f3ef",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "No Breed Restrictions",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f853f2e76c7b08d18d041814",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "On Site Laundry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5067954cca8c37e71bffde2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "On Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8778fdeb9d539e4e99c57528",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "On Site Property Manager",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c9def0b2c4775596c0aefe6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "One Car Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3349bf84d8e25c4567b4b222",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "On-Site Courtesy Officer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a725cd88f271d332eb5badc5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cbca8e4254997816b5e29d52",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Palladium Windows",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d4f7685f5efa1206bb09536",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Planned Social Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7dcc6c66d2ae466c566b306",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af16d41a7430d93cc7c766f6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_241d50d5dd30e844f3926f1c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Screened In Porch",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2251dbc0119b902adaf6d9ae",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Self Car Wash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5ffab7a67912c76eb4b73f2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Simulated Wood Plank",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef5d1aaeefb73835872efed2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Smart Home Technology",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_652cb5bfc656508ad1a47c2d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92f0762140b592a4954ae4e1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Units",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65e41b0c302f743876806ac6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Sunroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a96b9db30f4d281fe0f4fd7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Tile Flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19b259b3b6c2e33a16efb44c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Two Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f69797282d63d4d5211c2a1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Urban Vegetable Gardens",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_266b8c672fbcd36cc0ad1b64",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Vegetable Garden",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf2b3273512bfa135354e31f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer And Dryer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_403af9d945cfd5eba1cc3a12",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer Dryer Provided",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8008446d473fc6d94c788e13",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Wifi Hotspot",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d704d54665330cd994142bdf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c9a3e0b92ceb479e6fa124d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c81de6caf4700591929cf9c5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9810503cdbacfd88f3bb2170",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfdda25d498fc00ae06ead75",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be6968154828e0d3519a7004",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46819497f3e38adadae51b9c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f51f2432b900b3343028f04",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Security System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57e12646a7c8f3f1143847a7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Vanities",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa455aff67261caf9c3d0950",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e524981d1512e8931c15d160",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05193978513d7d76b506f2d7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2381cea37106e6ad113b55d9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51d8e3b58c3fd24f5af4183b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7f836681948580b1bcf7b56",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19d67eac525bd55d7f1e21fd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36486b5ba62d4cb3fede7dbc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f269e4317d7307307db3958b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3d3e715d2e8eacabadafa68",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4796182607178a7ee80a63ee",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c362eeea88fc7af66e51cc9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Tile Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67f087b7ad174da360ee9ad4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3bf7edf262851945a0c682b4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab780a50d62ff46365e3bdf5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Sunroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4ac99e08a5349b0269f8d61",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b14176bc567737727b49f5c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c68ccf39e2e993dcac1eb3b6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Furnished",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03b7f5d70e426c8d9ed88e33",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44706cc59f2b468f03d34f31",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca579fd637bd90f1e92b0c89",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8f90c9dc9f20417518c6687",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6f07a1168b6009b53ce4f08",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48d9459b8c0b2e7487fb9340",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d4bb975d94e39aa78a32895",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "apartments",
      "external_id": "false",
      "title": "Porch",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4c1d2cfe-d4f0-4edf-bd4d-65aeea619e8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a042fb-fc98-70c6-be33-11aa704183b2.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, free weights, and weight machines.",
        "public_id": "01a042fb-fc98-70c6-be33-11aa704183b2",
        "storage_key": "property/6767906449167728/01a042fb-fc98-70c6-be33-11aa704183b2.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, weight machines, and a free weight area.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, free weights, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7efec6f1-385a-4cf9-92ed-4996dea428c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-a5e2-771b-adbe-249921796e5d.webp",
      "image_media": {
        "alt_text": "Built-in desk area with white cabinets, granite countertop, and decorative orbs.",
        "public_id": "01a0353b-a5e2-771b-adbe-249921796e5d",
        "storage_key": "property/6767906449167728/01a0353b-a5e2-771b-adbe-249921796e5d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A stylish and functional built-in desk area featuring ample storage with white cabinetry and a granite countertop. Perfect for a home office or creative space.",
      "link": "",
      "alt_text": "Built-in desk area with white cabinets, granite countertop, and decorative orbs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1925db34-3e53-4ce9-a23d-5d5877e0f858",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-9abe-74ff-839e-1f183d301c5a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, white cabinets, stainless steel sink, and dishwasher. View of dining area and colorful art.",
        "public_id": "01a0353b-9abe-74ff-839e-1f183d301c5a",
        "storage_key": "property/6767906449167728/01a0353b-9abe-74ff-839e-1f183d301c5a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated kitchen featuring elegant granite countertops, crisp white cabinetry, and a double basin stainless steel sink. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, white cabinets, stainless steel sink, and dishwasher. View of dining area and colorful art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2e0b2677-b3af-47ce-ac20-d2f0cdc0b89b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-9295-71de-b065-e5ca250d01ec.webp",
      "image_media": {
        "alt_text": "Living room and dining area of an apartment with modern decor and colorful accents.",
        "public_id": "01a0353b-9295-71de-b065-e5ca250d01ec",
        "storage_key": "property/6767906449167728/01a0353b-9295-71de-b065-e5ca250d01ec.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish living and dining space featuring a comfortable sofa, vibrant orange chairs, and a large framed artwork. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area of an apartment with modern decor and colorful accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_442dad4d-7d63-4279-9cba-ec8809f1d15a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-8368-7088-a0bd-853d0e98bc1d.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, an orange accent chair, and abstract art.",
        "public_id": "01a0353b-8368-7088-a0bd-853d0e98bc1d",
        "storage_key": "property/6767906449167728/01a0353b-8368-7088-a0bd-853d0e98bc1d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright and inviting living room featuring a comfortable sofa, a stylish accent chair, and vibrant abstract art. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a white sofa, an orange accent chair, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24fe4ee8-6594-4bb8-828f-50b87404dfe2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-82c0-708a-ac81-906007328abe.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, orange and blue bedding, and two framed pictures on the wall.",
        "public_id": "01a0353b-82c0-708a-ac81-906007328abe",
        "storage_key": "property/6767906449167728/01a0353b-82c0-708a-ac81-906007328abe.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This bedroom features a comfortable bed adorned with vibrant orange and blue linens, perfect for a relaxing retreat. Two stylish framed artworks hang above the headboard.",
      "link": "",
      "alt_text": "Bedroom with a large bed, orange and blue bedding, and two framed pictures on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea9baed4-b033-4a06-974c-ebdaf7453d41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-76df-7429-b96d-3f1785ddce13.webp",
      "image_media": {
        "alt_text": "Dining area with a dark wood table and four orange chairs, looking towards the kitchen.",
        "public_id": "01a0353b-76df-7429-b96d-3f1785ddce13",
        "storage_key": "property/6767906449167728/01a0353b-76df-7429-b96d-3f1785ddce13.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern dining area featuring a dark wood table with vibrant orange chairs, adjacent to a pass-through kitchen with stainless steel appliances.",
      "link": "",
      "alt_text": "Dining area with a dark wood table and four orange chairs, looking towards the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_00479d7b-44f2-4358-93f8-67e6702bbe74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-721d-7548-9d1d-368676ff0135.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with white countertop, sink, and storage cabinets. Towels hang on the wall.",
        "public_id": "01a0353b-721d-7548-9d1d-368676ff0135",
        "storage_key": "property/6767906449167728/01a0353b-721d-7548-9d1d-368676ff0135.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with ample storage, a sleek countertop, and a large mirror. Decorated with stylish accents and clean white towels.",
      "link": "",
      "alt_text": "Bathroom vanity with white countertop, sink, and storage cabinets. Towels hang on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9f5bdde-3a52-4dea-853a-5f6103f1e029",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-560e-73bc-a783-6d1321274fcc.webp",
      "image_media": {
        "alt_text": "Open concept living area and kitchen with modern finishes.",
        "public_id": "01a0353b-560e-73bc-a783-6d1321274fcc",
        "storage_key": "property/6767906449167728/01a0353b-560e-73bc-a783-6d1321274fcc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area with a sleek, modern kitchen featuring granite countertops and stainless steel appliances.",
      "link": "",
      "alt_text": "Open concept living area and kitchen with modern finishes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c5e1ab25-5bc6-4a18-a862-18d9e7b17c28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-4f77-7168-9e3c-205248dfd33e.webp",
      "image_media": {
        "alt_text": "Aerial view of a sprawling apartment complex with a bright blue swimming pool and lush green landscaping, adjacent to a busy highway and a distant city skyline.",
        "public_id": "01a0353b-4f77-7168-9e3c-205248dfd33e",
        "storage_key": "property/6767906449167728/01a0353b-4f77-7168-9e3c-205248dfd33e.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Discover modern living in this vibrant community, featuring a sparkling swimming pool and easy access to the city. Enjoy the perfect blend of convenience and relaxation.",
      "link": "",
      "alt_text": "Aerial view of a sprawling apartment complex with a bright blue swimming pool and lush green landscaping, adjacent to a busy highway and a distant city skyline.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_32861381-22fa-4b32-8c95-470bf1993f18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-4ba5-75ac-880b-03e7a7340e4f.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical machines, weight machines, and free weights.",
        "public_id": "01a0353b-4ba5-75ac-880b-03e7a7340e4f",
        "storage_key": "property/6767906449167728/01a0353b-4ba5-75ac-880b-03e7a7340e4f.webp",
        "width": 1500,
        "height": 966
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio and strength training equipment for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed49fbef-f0a2-4b20-9f86-2f5896a03027",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-4b41-767b-a48f-72a185d3bf19.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with treadmills, weight machines, and free weights.",
        "public_id": "01a0353b-4b41-767b-a48f-72a185d3bf19",
        "storage_key": "property/6767906449167728/01a0353b-4b41-767b-a48f-72a185d3bf19.webp",
        "width": 1500,
        "height": 920
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide selection of cardio and strength training equipment for a comprehensive workout.",
      "link": "",
      "alt_text": "Fully equipped fitness center with treadmills, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9016b933-59b7-4d3a-99ce-95dcf5722bb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-406a-7148-92eb-be0a1ad3c551.webp",
      "image_media": {
        "alt_text": "Interior view of the gym entrance and hallway with seating",
        "public_id": "01a0353b-406a-7148-92eb-be0a1ad3c551",
        "storage_key": "property/6767906449167728/01a0353b-406a-7148-92eb-be0a1ad3c551.webp",
        "width": 1500,
        "height": 966
      },
      "title": "Community",
      "description": "Entrance to the state-of-the-art fitness center and hallway leading to other community amenities.",
      "link": "",
      "alt_text": "Interior view of the gym entrance and hallway with seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ccf14ecd-98c3-4c88-8293-4d5e9a43f7e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-3c44-7538-a0be-35c17e42a4bf.webp",
      "image_media": {
        "alt_text": "Kitchen island with sink and pendant lights, overlooking a lounge area with seating and windows with pool view.",
        "public_id": "01a0353b-3c44-7538-a0be-35c17e42a4bf",
        "storage_key": "property/6767906449167728/01a0353b-3c44-7538-a0be-35c17e42a4bf.webp",
        "width": 1500,
        "height": 966
      },
      "title": "Community",
      "description": "Modern communal kitchen island with sink and contemporary pendant lights, flowing into a comfortable lounge area with built-in seating and large windows offering views of the pool and outdoor amenities.",
      "link": "",
      "alt_text": "Kitchen island with sink and pendant lights, overlooking a lounge area with seating and windows with pool view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0a573c9e-239f-4317-9b74-5823d9dd8547",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-3904-723d-a270-f8175f29d07d.webp",
      "image_media": {
        "alt_text": "Community lounge area with seating, a bar, and outdoor views.",
        "public_id": "01a0353b-3904-723d-a270-f8175f29d07d",
        "storage_key": "property/6767906449167728/01a0353b-3904-723d-a270-f8175f29d07d.webp",
        "width": 1500,
        "height": 966
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, perfect for socializing or quiet enjoyment.",
      "link": "",
      "alt_text": "Community lounge area with seating, a bar, and outdoor views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e95b72fa-3999-4439-a6e8-d7246d036428",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-2aa0-730b-a089-0565437afa88.webp",
      "image_media": {
        "alt_text": "Stylish and inviting lobby area with comfortable seating, modern decor, and artistic touches.",
        "public_id": "01a0353b-2aa0-730b-a089-0565437afa88",
        "storage_key": "property/6767906449167728/01a0353b-2aa0-730b-a089-0565437afa88.webp",
        "width": 1500,
        "height": 966
      },
      "title": "Community",
      "description": "Discover the beautifully designed lobby, a welcoming space to relax and socialize, featuring elegant furnishings and unique artwork.",
      "link": "",
      "alt_text": "Stylish and inviting lobby area with comfortable seating, modern decor, and artistic touches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60bf846a-197a-49a6-9951-e914067c9fac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-1f4d-751b-aa53-22b93d80a455.webp",
      "image_media": {
        "alt_text": "Modern apartment building common area with pool view",
        "public_id": "01a0353b-1f4d-751b-aa53-22b93d80a455",
        "storage_key": "property/6767906449167728/01a0353b-1f4d-751b-aa53-22b93d80a455.webp",
        "width": 1500,
        "height": 966
      },
      "title": "Community",
      "description": "Elegant common area featuring a modern kitchen island, comfortable seating nooks, and direct views of the resort-style swimming pool and outdoor lounge.",
      "link": "",
      "alt_text": "Modern apartment building common area with pool view",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cf6dde8e-9ed4-442e-8e0a-6e87791d66cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-229e-73a7-b021-29a2c78e109c.webp",
      "image_media": {
        "alt_text": "Workstation with computer and chairs in a modern lobby with plants and art.",
        "public_id": "01a0353b-229e-73a7-b021-29a2c78e109c",
        "storage_key": "property/6767906449167728/01a0353b-229e-73a7-b021-29a2c78e109c.webp",
        "width": 1500,
        "height": 920
      },
      "title": "Community",
      "description": "This stylish and modern lobby features a long workstation equipped with a computer and comfortable seating, perfect for residents needing a quiet place to work or study. Decorated with vibrant artwork and lush greenery, the space offers a welcoming atmosphere.",
      "link": "",
      "alt_text": "Workstation with computer and chairs in a modern lobby with plants and art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d59d59bd-ea7f-4552-b0e4-b0ba28cacf75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-1e29-7184-a9c3-cdb2319c6de2.webp",
      "image_media": {
        "alt_text": "Community area with a dining table and chairs, and a reception desk in the background.",
        "public_id": "01a0353b-1e29-7184-a9c3-cdb2319c6de2",
        "storage_key": "property/6767906449167728/01a0353b-1e29-7184-a9c3-cdb2319c6de2.webp",
        "width": 1500,
        "height": 966
      },
      "title": "Community",
      "description": "A welcoming community space featuring a stylish dining area and a modern reception desk, perfect for residents to gather or receive services.",
      "link": "",
      "alt_text": "Community area with a dining table and chairs, and a reception desk in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e47245b-148b-4da0-93c2-47b2da4d3d77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-1c30-759f-953d-2747084ae579.webp",
      "image_media": {
        "alt_text": "Gated outdoor dog park with green turf and a dog washing station.",
        "public_id": "01a0353b-1c30-759f-953d-2747084ae579",
        "storage_key": "property/6767906449167728/01a0353b-1c30-759f-953d-2747084ae579.webp",
        "width": 1500,
        "height": 966
      },
      "title": "Community",
      "description": "Enjoy our convenient and clean outdoor dog park, perfect for your furry friends to play and socialize. Features include artificial turf and a dog wash station.",
      "link": "",
      "alt_text": "Gated outdoor dog park with green turf and a dog washing station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8f642b4-4f92-4e04-ac3a-3bb27aaaf74e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-12a7-7680-9c46-31f76039db25.webp",
      "image_media": {
        "alt_text": "Dog park and spa area at MAA Hyde Park.",
        "public_id": "01a0353b-12a7-7680-9c46-31f76039db25",
        "storage_key": "property/6767906449167728/01a0353b-12a7-7680-9c46-31f76039db25.webp",
        "width": 1300,
        "height": 881
      },
      "title": "Community",
      "description": "Enjoy our convenient dog park and spa, a perfect place for your furry friends to play and relax.",
      "link": "",
      "alt_text": "Dog park and spa area at MAA Hyde Park.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_12dd84d9-7da7-45f2-b480-788e792ee84a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-0dbf-74b3-bddb-40699ac46629.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen and dining area with grills, seating, and a fireplace.",
        "public_id": "01a0353b-0dbf-74b3-bddb-40699ac46629",
        "storage_key": "property/6767906449167728/01a0353b-0dbf-74b3-bddb-40699ac46629.webp",
        "width": 1300,
        "height": 837
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and entertaining in our community's outdoor kitchen and lounge area, featuring built-in grills, comfortable seating, and a cozy fireplace.",
      "link": "",
      "alt_text": "Outdoor kitchen and dining area with grills, seating, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0df6003c-c6ac-4bf8-9920-ad6cea8e4f4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-0732-75d9-a399-01ff8b1358ea.webp",
      "image_media": {
        "alt_text": "Outdoor patio with tables and chairs under a wooden pergola, overlooking a landscaped area and seating areas.",
        "public_id": "01a0353b-0732-75d9-a399-01ff8b1358ea",
        "storage_key": "property/6767906449167728/01a0353b-0732-75d9-a399-01ff8b1358ea.webp",
        "width": 1200,
        "height": 773
      },
      "title": "Community",
      "description": "Enjoy the outdoors on our spacious patio, featuring comfortable seating, dining areas, and lush landscaping, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Outdoor patio with tables and chairs under a wooden pergola, overlooking a landscaped area and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_717920d0-be1b-4c65-bb2a-d0b1fe4f16f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-079e-7571-b396-95c991b51be4.webp",
      "image_media": {
        "alt_text": "Outdoor patio with seating, tables, and bar area.",
        "public_id": "01a0353b-079e-7571-b396-95c991b51be4",
        "storage_key": "property/6767906449167728/01a0353b-079e-7571-b396-95c991b51be4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our spacious patio, featuring a bar, dining tables, and comfortable seating areas perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor patio with seating, tables, and bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f985ded-b0af-447e-86fa-5d93991e6115",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-f779-71a4-a99c-f16c27cc26be.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with a modern fireplace and seating, adjacent to a covered patio with tables and chairs.",
        "public_id": "01a0353a-f779-71a4-a99c-f16c27cc26be",
        "storage_key": "property/6767906449167728/01a0353a-f779-71a4-a99c-f16c27cc26be.webp",
        "width": 1200,
        "height": 773
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed outdoor lounge area, featuring a contemporary fireplace and comfortable seating, perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor lounge area with a modern fireplace and seating, adjacent to a covered patio with tables and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96127ecf-fdca-471d-a277-56e95affe461",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-f405-77ba-a373-2b28a22cc89e.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with seating and tables next to a swimming pool and lounge chairs.",
        "public_id": "01a0353a-f405-77ba-a373-2b28a22cc89e",
        "storage_key": "property/6767906449167728/01a0353a-f405-77ba-a373-2b28a22cc89e.webp",
        "width": 1500,
        "height": 966
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor lounge area, complete with comfortable seating and shaded pergolas, perfect for enjoying the sunshine by the sparkling pool.",
      "link": "",
      "alt_text": "Outdoor lounge area with seating and tables next to a swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6cb1ba69-7fe7-4573-a268-203257698825",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-f2f8-7259-893a-1a3b0836376a.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a vertical garden wall next to a swimming pool.",
        "public_id": "01a0353a-f2f8-7259-893a-1a3b0836376a",
        "storage_key": "property/6767906449167728/01a0353a-f2f8-7259-893a-1a3b0836376a.webp",
        "width": 1300,
        "height": 837
      },
      "title": "Community",
      "description": "Relax under the pergola in the comfortable outdoor seating area, adjacent to the vibrant vertical garden and sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor seating area with a vertical garden wall next to a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74d1265d-e6fa-482f-85fd-532e6e46f365",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-ed72-75fb-8895-bc3cce52e89a.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating area.",
        "public_id": "01a0353a-ed72-75fb-8895-bc3cce52e89a",
        "storage_key": "property/6767906449167728/01a0353a-ed72-75fb-8895-bc3cce52e89a.webp",
        "width": 1500,
        "height": 966
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool, complete with comfortable lounge chairs and an inviting outdoor seating area perfect for socializing or enjoying a meal al fresco.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1cc2e892-72ee-4419-9505-b12fb62c1dff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-d529-75f3-b535-fad1c6615b4a.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and patio seating.",
        "public_id": "01a0353a-d529-75f3-b535-fad1c6615b4a",
        "storage_key": "property/6767906449167728/01a0353a-d529-75f3-b535-fad1c6615b4a.webp",
        "width": 1500,
        "height": 942
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with ample lounge chairs and comfortable patio seating for relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and patio seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f7e98c3b-34fd-423c-ad5d-94f411e519c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353a-d324-71d6-ba32-9d87f0649353.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a view into a bedroom.",
        "public_id": "01a0353a-d324-71d6-ba32-9d87f0649353",
        "storage_key": "property/6767906449167728/01a0353a-d324-71d6-ba32-9d87f0649353.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Stylish living and dining area featuring a modern dining set and comfortable sofa, with a peek into a well-appointed bedroom.",
      "link": "",
      "alt_text": "Living room and dining area with a view into a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24295835-1834-4a21-a52e-f64b0c9ef0f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-ef3e-72eb-bf5f-6adea9dcf511.webp",
      "image_media": {
        "alt_text": "Resort-style pool and lounge area with palm trees and apartment building.",
        "public_id": "01a03539-ef3e-72eb-bf5f-6adea9dcf511",
        "storage_key": "property/6767906449167728/01a03539-ef3e-72eb-bf5f-6adea9dcf511.webp",
        "width": 3072,
        "height": 2199
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool, complete with comfortable lounge chairs, umbrellas, and lush tropical landscaping.",
      "link": "",
      "alt_text": "Resort-style pool and lounge area with palm trees and apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9d3b68a0-c52b-4f86-abb0-ca14701e4e93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-e58e-746f-809d-ac39eedc9cab.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs at sunset.",
        "public_id": "01a03539-e58e-746f-809d-ac39eedc9cab",
        "storage_key": "property/6767906449167728/01a03539-e58e-746f-809d-ac39eedc9cab.webp",
        "width": 3072,
        "height": 2020
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, perfect for a refreshing dip or soaking up the sun. Enjoy the beautiful sunset views.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a69b402f-f789-44e3-a3ee-486b6fdae2e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-ddf9-7091-9dc7-de5ea19626c9.webp",
      "image_media": {
        "alt_text": "Stylish living room with a neutral color palette, coffered ceiling, and large windows.",
        "public_id": "01a03539-ddf9-7091-9dc7-de5ea19626c9",
        "storage_key": "property/6767906449167728/01a03539-ddf9-7091-9dc7-de5ea19626c9.webp",
        "width": 3072,
        "height": 2220
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living space, featuring a refined neutral palette and elegant coffered ceiling. Large windows bathe the room in natural light, creating a serene atmosphere.",
      "link": "",
      "alt_text": "Stylish living room with a neutral color palette, coffered ceiling, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0432bf35-1f05-420f-9b4e-6a5fd2b1e03c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-e00b-761a-a463-b113efb0a38a.webp",
      "image_media": {
        "alt_text": "Treadmills and weight machines in a modern fitness center.",
        "public_id": "01a03539-e00b-761a-a463-b113efb0a38a",
        "storage_key": "property/6767906449167728/01a03539-e00b-761a-a463-b113efb0a38a.webp",
        "width": 3072,
        "height": 1883
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, free weights, and weightlifting equipment.",
      "link": "",
      "alt_text": "Treadmills and weight machines in a modern fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6bb9cedd-5e6f-4878-abc9-3406be9a9169",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-d0bf-744a-94e1-49c43fe46aa9.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with a pool table, seating, and bar area.",
        "public_id": "01a03539-d0bf-744a-94e1-49c43fe46aa9",
        "storage_key": "property/6767906449167728/01a03539-d0bf-744a-94e1-49c43fe46aa9.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy our spacious community lounge featuring a pool table, comfortable seating, and a full-service bar area, perfect for socializing and relaxation.",
      "link": "",
      "alt_text": "Modern community lounge area with a pool table, seating, and bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_144c6f77-e85b-4ebf-b836-48b19be6463a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-d775-7453-8dd5-966a6c151779.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen in a loft apartment with exposed brick walls and large windows.",
        "public_id": "01a03539-d775-7453-8dd5-966a6c151779",
        "storage_key": "property/6767906449167728/01a03539-d775-7453-8dd5-966a6c151779.webp",
        "width": 1728,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Experience sophisticated urban living in this stunning loft apartment, featuring exposed brick, high ceilings, and a modern open-concept kitchen.",
      "link": "",
      "alt_text": "Spacious living room and kitchen in a loft apartment with exposed brick walls and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b89783ba-b924-4203-802d-b87c3b0a8562",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-a256-73fb-8c3a-691f0c266c4a.webp",
      "image_media": {
        "alt_text": "A communal workspace with a long counter, computers, and chairs.",
        "public_id": "01a03539-a256-73fb-8c3a-691f0c266c4a",
        "storage_key": "property/6767906449167728/01a03539-a256-73fb-8c3a-691f0c266c4a.webp",
        "width": 3072,
        "height": 1883
      },
      "title": "Community",
      "description": "Utilize the resident workspace, complete with computers and comfortable seating, perfect for getting work done or browsing online.",
      "link": "",
      "alt_text": "A communal workspace with a long counter, computers, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60d7e285-f460-44b9-a0e3-bef675252422",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-a1e1-70fd-9a36-d52d299a9cf8.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with bar stools and pendant lights.",
        "public_id": "01a03539-a1e1-70fd-9a36-d52d299a9cf8",
        "storage_key": "property/6767906449167728/01a03539-a1e1-70fd-9a36-d52d299a9cf8.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Stylish kitchen island featuring a quartz countertop, comfortable bar stools, and elegant pendant lighting, perfect for casual dining and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen island with bar stools and pendant lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f4b681a-f61b-4aa5-93e7-9b746d141699",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-9c7b-72e6-a5b5-5825759ada0f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a03539-9c7b-72e6-a5b5-5825759ada0f",
        "storage_key": "property/6767906449167728/01a03539-9c7b-72e6-a5b5-5825759ada0f.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our stunning resort-style swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for unwinding or taking a refreshing dip.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eed6a6ee-e6d8-4ba0-a697-7eb25f941b78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-9a39-73ee-9ffb-80f82b83d4ac.webp",
      "image_media": {
        "alt_text": "Hanging egg chairs in a modern lounge area with a wood-paneled wall and large windows.",
        "public_id": "01a03539-9a39-73ee-9ffb-80f82b83d4ac",
        "storage_key": "property/6767906449167728/01a03539-9a39-73ee-9ffb-80f82b83d4ac.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax in style in our stylish lounge area, featuring comfortable hanging egg chairs and a modern aesthetic. Perfect for socializing or unwinding.",
      "link": "",
      "alt_text": "Hanging egg chairs in a modern lounge area with a wood-paneled wall and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec478e1b-ac07-49c8-a52e-5cacabe385c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-99c9-70eb-8b00-333af40cb4a1.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, weight machines, dumbbells, and TVs.",
        "public_id": "01a03539-99c9-70eb-8b00-333af40cb4a1",
        "storage_key": "property/6767906449167728/01a03539-99c9-70eb-8b00-333af40cb4a1.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with cardio machines, weight machines, dumbbells, and TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5f83e13-0b4f-4838-966b-a9faee161be3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-9a92-764e-b311-115113652523.webp",
      "image_media": {
        "alt_text": "Dining area with a rustic wooden table and plush pink chairs near large windows.",
        "public_id": "01a03539-9a92-764e-b311-115113652523",
        "storage_key": "property/6767906449167728/01a03539-9a92-764e-b311-115113652523.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in this spacious area, perfect for hosting gatherings or intimate meals, with abundant natural light.",
      "link": "",
      "alt_text": "Dining area with a rustic wooden table and plush pink chairs near large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_1575925298ff315cf13af60b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Bern's Steak House",
      "poi_type": "Restaurants",
      "poi_address": "1208 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Opened in 1956, this destination features dry-aged steaks, a huge wine list & flocked wallpaper.",
      "poi_long_description": "Opened in 1956, this destination features dry-aged steaks, a huge wine list & flocked wallpaper.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-acbe-77dc-af76-1992157f9670.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-acbe-77dc-af76-1992157f9670",
        "storage_key": "property/6767906449167728/01a0353b-acbe-77dc-af76-1992157f9670.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.bernssteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11684552119218294820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "berns-steak-house",
      "poi_latitude": "27.9316028",
      "poi_longitude": "-82.48285179999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-251-2421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKQXHdmfDwogRJFCLuT7eJ6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_f1a92a65451397aa3bf13ecd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Elevage SoHo Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1207 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Upscale all-day restaurant serving creative renditions of American classics in the Epicurean Hotel.",
      "poi_long_description": "Upscale all-day restaurant serving creative renditions of American classics in the Epicurean Hotel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-b219-73c8-afdf-86c1ebdd4b8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-b219-73c8-afdf-86c1ebdd4b8d",
        "storage_key": "property/6767906449167728/01a0353b-b219-73c8-afdf-86c1ebdd4b8d.webp",
        "width": 1280,
        "height": 876
      },
      "poi_business_url": "http://elevagerestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4746901042356929338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elevage-soho-kitchen--bar",
      "poi_latitude": "27.9305556",
      "poi_longitude": "-82.4833333",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-999-8771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE50sgWfDwogROsOdDVlh4EE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_863478fc052343481773bebe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "On Swann",
      "poi_type": "Restaurants",
      "poi_address": "1501 W Swann Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Seasonal New American cuisine prepared in an open-concept kitchen in a chic, lofty eatery.",
      "poi_long_description": "Seasonal New American cuisine prepared in an open-concept kitchen in a chic, lofty eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-ae21-73e8-9833-abeef408da18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-ae21-73e8-9833-abeef408da18",
        "storage_key": "property/6767906449167728/01a0353b-ae21-73e8-9833-abeef408da18.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://onswann.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11938981105801394242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-swann",
      "poi_latitude": "27.9374672",
      "poi_longitude": "-82.4749343",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-251-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5crCip3EwogRQnhkbw_Ir6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_748ee1b5c6ce671264d57b6c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Timpano Hyde Park",
      "poi_type": "Restaurants",
      "poi_address": "1610 W Swann Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Elegant Italian steakhouse offering cozy booths in a chandeliered space with occasional live music.",
      "poi_long_description": "Elegant Italian steakhouse offering cozy booths in a chandeliered space with occasional live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-afc8-76cd-8220-485074459c76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-afc8-76cd-8220-485074459c76",
        "storage_key": "property/6767906449167728/01a0353b-afc8-76cd-8220-485074459c76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://timpanohydepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=166885442754983208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timpano-hyde-park",
      "poi_latitude": "27.9371498",
      "poi_longitude": "-82.47604",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 813-254-5870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcNdEmLDwogRKDWYDW3lUAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_d19ff800b10a18348441cf86",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Meat Market Steakhouse Tampa",
      "poi_type": "Restaurants",
      "poi_address": "1606 W Snow Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Stunning steakhouse featuring a Miami Beach vibe, seafood, sushi and craft cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-b5e5-71ab-b191-162857b673e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-b5e5-71ab-b191-162857b673e8",
        "storage_key": "property/6767906449167728/01a0353b-b5e5-71ab-b191-162857b673e8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.meatmarket.net/location/meat-market-tampa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10778224991567861108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meat-market-steakhouse-tampa",
      "poi_latitude": "27.935898",
      "poi_longitude": "-82.47608149999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-280-1113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwli6xvDwogRdNWjO4byk5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_66718034fda08998f08f1ee8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "bartaco",
      "poi_type": "Restaurants",
      "poi_address": "1601 W Snow Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Relaxed chain taco joint serving pork belly, fish, and cauliflower tacos.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-b260-7538-93e4-8e10caf63881.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-b260-7538-93e4-8e10caf63881",
        "storage_key": "property/6767906449167728/01a0353b-b260-7538-93e4-8e10caf63881.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://bartaco.com/location/tampa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10023402577441988027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bartaco",
      "poi_latitude": "27.9362248",
      "poi_longitude": "-82.4760119",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-258-8226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZWIHmLDwogRux0qtYlHGos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "ec_8143cbfca32d371fb64b3bcf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Ro Hyde Park Sushi Bar & Asian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1500 W Swann Ave, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-ac8c-722c-84ce-658c6a3b4a7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-ac8c-722c-84ce-658c6a3b4a7e",
        "storage_key": "property/6767906449167728/01a0353b-ac8c-722c-84ce-658c6a3b4a7e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.rohydepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2487766299205967308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ro-hyde-park-sushi-bar--asian-restaurant",
      "poi_latitude": "27.9371704",
      "poi_longitude": "-82.474997",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-536-5153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe_sgCQTFwogRzB1ctERShiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_85684e6399155694089d297c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Pane Rustica",
      "poi_type": "Restaurants",
      "poi_address": "3225 S MacDill Ave, Tampa, FL 33629, USA",
      "poi_short_description": "Strip-mall setting for casual breakfast & lunch fare plus a global dinner menu & cocktails at night.",
      "poi_long_description": "Strip-mall setting for casual breakfast & lunch fare plus a global dinner menu & cocktails at night.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-b51c-734e-a2d7-3f4322c347ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-b51c-734e-a2d7-3f4322c347ad",
        "storage_key": "property/6767906449167728/01a0353b-b51c-734e-a2d7-3f4322c347ad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://panerusticabakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2750642868981519518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pane-rustica",
      "poi_latitude": "27.9159811",
      "poi_longitude": "-82.4943064",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-902-8828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8VznqEnDwogRntSapR0_LCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_689beb5fe8509ac394fb5c54",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Bosc Modern Bar + Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "201 W Platt St Ste a, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-afb2-73ae-b281-1cab57198041.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-afb2-73ae-b281-1cab57198041",
        "storage_key": "property/6767906449167728/01a0353b-afb2-73ae-b281-1cab57198041.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://bosctampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=100515552020592771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bosc-modern-bar--kitchen",
      "poi_latitude": "27.9418969",
      "poi_longitude": "-82.4611845",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-253-5346",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40H_o1zFwogRg_iWrFwaZQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_80a72f4d58576da5d47474ae",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Buddy Brew Coffee",
      "poi_type": "Restaurants",
      "poi_address": "Buddy Brew Coffee - Hyde Park, 1605 W Snow Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Charming fixture featuring specialty coffee, beer and wine alongside sandwiches, pastries, cookies, yogurt, soups, cakes and cookies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-ad05-7057-af8f-ca7a488799c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-ad05-7057-af8f-ca7a488799c1",
        "storage_key": "property/6767906449167728/01a0353b-ad05-7057-af8f-ca7a488799c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.buddybrew.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13420824593703302480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buddy-brew-coffee",
      "poi_latitude": "27.9361321",
      "poi_longitude": "-82.4761963",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-575-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e51-76bf-9be7-2e95bd189f5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e51-76bf-9be7-2e95bd189f5b",
        "storage_key": "property/6767906449167728/01a0353c-0e51-76bf-9be7-2e95bd189f5b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJRezwHGLDwogRUPWChNxYQLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_d43633ac4aeb61cb4f12477d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "The Salty Donut",
      "poi_type": "Restaurants",
      "poi_address": "1519 W Swann Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Casual, family-friendly bakery focused on gourmet donuts and drinks including tea and coffee.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-b6cd-71a9-a3d4-4be14025bd02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-b6cd-71a9-a3d4-4be14025bd02",
        "storage_key": "property/6767906449167728/01a0353b-b6cd-71a9-a3d4-4be14025bd02.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.saltydonut.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14690891318079042940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-salty-donut",
      "poi_latitude": "27.9375007",
      "poi_longitude": "-82.4754801",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 813-550-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsQXFJ47DwogRfLX4b9GH4Ms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "ec_e1566e7e743f0510217b978f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Koto Japanese Steak House",
      "poi_type": "Restaurants",
      "poi_address": "533 S Howard Ave #4, Tampa, FL 33606, USA",
      "poi_short_description": "Japanese restaurant specializing in tableside hibachi & sushi in subdued, contemporary environs.",
      "poi_long_description": "Japanese restaurant specializing in tableside hibachi & sushi in subdued, contemporary environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-b9d0-77cb-aa6f-27aff847bd82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-b9d0-77cb-aa6f-27aff847bd82",
        "storage_key": "property/6767906449167728/01a0353b-b9d0-77cb-aa6f-27aff847bd82.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.kotosteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13001479127278775756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "koto-japanese-steak-house",
      "poi_latitude": "27.9392336",
      "poi_longitude": "-82.48334249999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-964-6808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo-6FVmTDwogRzG0bqGGIbrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_94aab4fc1f9e6193b4db5500",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Gio's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "411 S MacDill Ave, Tampa, FL 33609, USA",
      "poi_short_description": "Counter-service joint offering a Cuban menu in a bare-bones setting with limited outdoor seating.",
      "poi_long_description": "Counter-service joint offering a Cuban menu in a bare-bones setting with limited outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-b7e9-77e5-897f-c595dbbca544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-b7e9-77e5-897f-c595dbbca544",
        "storage_key": "property/6767906449167728/01a0353b-b7e9-77e5-897f-c595dbbca544.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.gioscubancafe.getsauce.com/?utm_source=GMB&utm_medium=Website+Button&utm_id=gioscubancafe",
      "poi_directions_map_url": "https://maps.google.com/?cid=16698601837560920007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gios-cafe",
      "poi_latitude": "27.9405107",
      "poi_longitude": "-82.4936642",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-324-6118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpaW4r23DwogRx_eA9eVZvec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cuban_restaurant"
    },
    {
      "id": "ec_505640ff4e9c82dc3f2b0b60",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Oxford Exchange",
      "poi_type": "Restaurants",
      "poi_address": "420 W Kennedy Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "European-inspired space featuring a restaurant, bookstore, coffeehouse & shop with decor & gifts.",
      "poi_long_description": "European-inspired space featuring a restaurant, bookstore, coffeehouse & shop with decor & gifts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-12b0-77bc-a5eb-eb80a9e3b635.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03539-12b0-77bc-a5eb-eb80a9e3b635",
        "storage_key": "property/6767906449167728/01a03539-12b0-77bc-a5eb-eb80a9e3b635.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://oxfordexchange.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11520336291559321740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxford-exchange",
      "poi_latitude": "27.9449261",
      "poi_longitude": "-82.4646338",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-253-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11hsiYXEwogRjDBv39F04J8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_3b3f4a8c8c641e63a04c0e6c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "The Bungalow Restaurant and Bar",
      "poi_type": "Restaurants",
      "poi_address": "2202 W Kennedy Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "Bar snacks are the specialty at this laid-back hub with sports on TV & drinks.",
      "poi_long_description": "Bar snacks are the specialty at this laid-back hub with sports on TV & drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-c141-71b3-b222-25aaa7610851.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-c141-71b3-b222-25aaa7610851",
        "storage_key": "property/6767906449167728/01a0353b-c141-71b3-b222-25aaa7610851.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12182580726539495103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bungalow-restaurant-and-bar",
      "poi_latitude": "27.944441",
      "poi_longitude": "-82.482171",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-253-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7_SoDXvDwogRvybo7J84Eak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_02eaf5ec66e6f2639e76648f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Hyde Park Village Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "742 S Village Cir, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-bb0e-75db-8e36-dfebf8e8ded4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-bb0e-75db-8e36-dfebf8e8ded4",
        "storage_key": "property/6767906449167728/01a0353b-bb0e-75db-8e36-dfebf8e8ded4.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.tampabaymarkets.com/fresh-market-at-hyde-park-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=9937126896625391940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyde-park-village-fresh-market",
      "poi_latitude": "27.9364549",
      "poi_longitude": "-82.4751943",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e6e-70cb-8d30-6db70d1c5846.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e6e-70cb-8d30-6db70d1c5846",
        "storage_key": "property/6767906449167728/01a03539-4e6e-70cb-8d30-6db70d1c5846.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsTZmISDFwogRRBlWaUPE54k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "ec_b48a9051ad2b93e9884266ca",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-c08e-754f-b709-c0f15dad79fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-c08e-754f-b709-c0f15dad79fc",
        "storage_key": "property/6767906449167728/01a0353b-c08e-754f-b709-c0f15dad79fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/fl/tampa/1001-s.-howard-avenue-40420?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18357205813550546355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "27.9334773",
      "poi_longitude": "-82.4832923",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-254-3969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e53-700f-a239-41e3c22f80c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e53-700f-a239-41e3c22f80c1",
        "storage_key": "property/6767906449167728/01a0353c-0e53-700f-a239-41e3c22f80c1.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJY_zyvwnDwogRs31qQW3lwf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_984d32ba0d43edfb0ea1d29d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "611 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-c09d-7549-be77-6cb7b719201a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-c09d-7549-be77-6cb7b719201a",
        "storage_key": "property/6767906449167728/01a0353b-c09d-7549-be77-6cb7b719201a.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/tampa-fl-pharmacies/611-s-howard-ave-tampa-fl-33606/storeid=3930?WT.mc_id=LS_GOOGLE_RX_3930",
      "poi_directions_map_url": "https://maps.google.com/?cid=9578096897238836436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "27.9377195",
      "poi_longitude": "-82.4835727",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 813-259-9911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e40-729e-a03c-6dac119c3bec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e40-729e-a03c-6dac119c3bec",
        "storage_key": "property/6767906449167728/01a0353c-0e40-729e-a03c-6dac119c3bec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSVbymXDwogR1CQxkGE87IQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_65f2babe076b4699bb85f9e7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Publix Super Market on Bayshore",
      "poi_type": "Shopping & Retail",
      "poi_address": "243 Bayshore Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-c332-7175-89d8-21c430692174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-c332-7175-89d8-21c430692174",
        "storage_key": "property/6767906449167728/01a0353b-c332-7175-89d8-21c430692174.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=628&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=7715569998516166893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-on-bayshore",
      "poi_latitude": "27.9422049",
      "poi_longitude": "-82.46053169999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-251-1173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-23264d62ba6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-23264d62ba6d",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-23264d62ba6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1anFFY7EwogR7aA36Qg2E2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_a8d4d71102e55d182ceae1af",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1601 W Kennedy Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "Large, chain store featuring a bakery and a pharmacy along with groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-c2dc-705f-aa8c-dd7ce7794024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-c2dc-705f-aa8c-dd7ce7794024",
        "storage_key": "property/6767906449167728/01a0353b-c2dc-705f-aa8c-dd7ce7794024.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/5760-tampa-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3239033025189180473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "27.9456146",
      "poi_longitude": "-82.47614279999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-254-6125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-23264d62ba6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-23264d62ba6d",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-23264d62ba6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXViPhX3DwogROfQoEmBb8yw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_edf15df2720fdb004a8ae7b3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Hyde Park Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "1602 W Snow Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Stylish open-air complex with higher-end retailers, restaurants & bars, plus a movie theater.",
      "poi_long_description": "Stylish open-air complex with higher-end retailers, restaurants & bars, plus a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-1864-730c-beb5-a2295e1d6cd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03539-1864-730c-beb5-a2295e1d6cd3",
        "storage_key": "property/6767906449167728/01a03539-1864-730c-beb5-a2295e1d6cd3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://hydeparkvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7521361268052889209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyde-park-village",
      "poi_latitude": "27.93665",
      "poi_longitude": "-82.4759751",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-251-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e6e-70cb-8d30-6db70d1c5846.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e6e-70cb-8d30-6db70d1c5846",
        "storage_key": "property/6767906449167728/01a03539-4e6e-70cb-8d30-6db70d1c5846.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQZRp15bDwogReY6sMTk-YWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_cdcfdc997672f605025f23c3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "west elm",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 S Village Cir, Tampa, FL 33606, USA",
      "poi_short_description": "Chain retailer offering a huge selection of modern furniture, home accessories & kitchen items.",
      "poi_long_description": "Chain retailer offering a huge selection of modern furniture, home accessories & kitchen items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-c4cc-731a-9b16-795bd30bb86c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-c4cc-731a-9b16-795bd30bb86c",
        "storage_key": "property/6767906449167728/01a0353b-c4cc-731a-9b16-795bd30bb86c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.westelm.com/stores/us-fl-tampa-hyde-park-village/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13276880146948421423&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-elm",
      "poi_latitude": "27.9368866",
      "poi_longitude": "-82.4755534",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-251-1052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e6e-70cb-8d30-6db70d1c5846.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e6e-70cb-8d30-6db70d1c5846",
        "storage_key": "property/6767906449167728/01a03539-4e6e-70cb-8d30-6db70d1c5846.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9zdzBWLDwogRL_dLVCb0QLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_e87aeb3372585a2515162343",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Pottery Barn",
      "poi_type": "Shopping & Retail",
      "poi_address": "802 S Village Cir, Tampa, FL 33606, USA",
      "poi_short_description": "This upscale furniture chain also sells bed & bath items, tableware, lighting & other home goods.",
      "poi_long_description": "This upscale furniture chain also sells bed & bath items, tableware, lighting & other home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-c8b6-7459-8eba-10f0f433713d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-c8b6-7459-8eba-10f0f433713d",
        "storage_key": "property/6767906449167728/01a0353b-c8b6-7459-8eba-10f0f433713d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.potterybarn.com/stores/us-fl-tampa-old-hyde-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4432483088101496993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pottery-barn",
      "poi_latitude": "27.9359331",
      "poi_longitude": "-82.4756009",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-253-0904",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e6e-70cb-8d30-6db70d1c5846.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e6e-70cb-8d30-6db70d1c5846",
        "storage_key": "property/6767906449167728/01a03539-4e6e-70cb-8d30-6db70d1c5846.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOezMB2LDwogRoVg3Y-JXgz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_592d0fc021cf6316b41bc2e6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Armature Works",
      "poi_type": "Restaurants",
      "poi_address": "1910 N Ola Ave, Tampa, FL 33602, USA",
      "poi_short_description": "Striking mixed-use event space offering an upscale food court, bar & lounge in lofty, historic digs.",
      "poi_long_description": "Striking mixed-use event space offering an upscale food court, bar & lounge in lofty, historic digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-19b4-7433-9e5f-e7d9a8af0cac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03539-19b4-7433-9e5f-e7d9a8af0cac",
        "storage_key": "property/6767906449167728/01a03539-19b4-7433-9e5f-e7d9a8af0cac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://armatureworks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15923683446625658433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armature-works",
      "poi_latitude": "27.9609343",
      "poi_longitude": "-82.4642724",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 813-250-3725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWj9iZ_PwogRQebjN7pJ_Nw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_5f3e1b76e50dff379ede3e04",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Mitchell Elementary School",
      "poi_type": "Education",
      "poi_address": "205 S Bungalow Park Ave, Tampa, FL 33609, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-c547-76cc-9ea6-6f01f4b53f6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-c547-76cc-9ea6-6f01f4b53f6d",
        "storage_key": "property/6767906449167728/01a0353b-c547-76cc-9ea6-6f01f4b53f6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mitchell.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3290811859563220078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mitchell-elementary-school",
      "poi_latitude": "27.9433665",
      "poi_longitude": "-82.490647",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-872-5216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGY5j43HDwogRbozoZ_NPqy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_9ac996d056c2740084726c10",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Wilson Middle School",
      "poi_type": "Education",
      "poi_address": "1005 W Swann Ave, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-c727-72bc-8a0c-7b0b1dd2c70a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-c727-72bc-8a0c-7b0b1dd2c70a",
        "storage_key": "property/6767906449167728/01a0353b-c727-72bc-8a0c-7b0b1dd2c70a.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "http://wilsonms.mysdhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5047233007986041845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilson-middle-school",
      "poi_latitude": "27.937595",
      "poi_longitude": "-82.46998719999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-276-5682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJodBp04nFwogR9WOi661fC0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_8d1de67dc142c42c56b934ed",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Gorrie Elementary School",
      "poi_type": "Education",
      "poi_address": "705 W De Leon St, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-c91c-71d3-a307-38329443886f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-c91c-71d3-a307-38329443886f",
        "storage_key": "property/6767906449167728/01a0353b-c91c-71d3-a307-38329443886f.webp",
        "width": 588,
        "height": 294
      },
      "poi_business_url": "https://www.hillsboroughschools.org/gorrie",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500986170500142071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gorrie-elementary-school",
      "poi_latitude": "27.939443",
      "poi_longitude": "-82.46695629999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-276-5673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6ca_EJvEwogR91NXu_y1m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_b5ea594e92bdce2742c895ea",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "H. B. Plant High School",
      "poi_type": "Education",
      "poi_address": "2415 S Himes Ave, Tampa, FL 33629, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-cbb2-7154-a09a-1d1465bb48a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-cbb2-7154-a09a-1d1465bb48a2",
        "storage_key": "property/6767906449167728/01a0353b-cbb2-7154-a09a-1d1465bb48a2.webp",
        "width": 1280,
        "height": 900
      },
      "poi_business_url": "https://www.hillsboroughschools.org/plant",
      "poi_directions_map_url": "https://maps.google.com/?cid=1787809284984185336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-b-plant-high-school",
      "poi_latitude": "27.9238864",
      "poi_longitude": "-82.5022195",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-272-3033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQTEGaSDDwogR-KGgjRKTzxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_029ac7911e3b1c3b07a2faf1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Tampa Preparatory School",
      "poi_type": "Education",
      "poi_address": "727 W Cass St, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-cd01-72e5-a341-cf97589cc890.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-cd01-72e5-a341-cf97589cc890",
        "storage_key": "property/6767906449167728/01a0353b-cd01-72e5-a341-cf97589cc890.webp",
        "width": 1280,
        "height": 947
      },
      "poi_business_url": "https://tampaprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13698294515783081250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-preparatory-school",
      "poi_latitude": "27.95152",
      "poi_longitude": "-82.4677325",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-251-8481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjzUioYfEwogRIp3uEUkeGr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_596e0a183fb915bf8403420b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "The University of Tampa",
      "poi_type": "Education",
      "poi_address": "401 W Kennedy Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-1c0a-77cd-bbe7-30a4a8761117.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03539-1c0a-77cd-bbe7-30a4a8761117",
        "storage_key": "property/6767906449167728/01a03539-1c0a-77cd-bbe7-30a4a8761117.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.ut.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5456992893672379865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-tampa",
      "poi_latitude": "27.9468757",
      "poi_longitude": "-82.46722659999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-253-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ90AFeYbEwogR2VUs2R8iu0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_156fce02441c9767e4a9c2a1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Primrose School of South Tampa",
      "poi_type": "Education",
      "poi_address": "1700 W Kennedy Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "Toddler and pre-K curriculum in an upbeat setting with playgrounds and care-centered staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-cc14-7268-84c1-d89fbfbd0793.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-cc14-7268-84c1-d89fbfbd0793",
        "storage_key": "property/6767906449167728/01a0353b-cc14-7268-84c1-d89fbfbd0793.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/south-tampa/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=410260746038977856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-south-tampa",
      "poi_latitude": "27.9441398",
      "poi_longitude": "-82.47719390000002",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-876-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEQlbCn3DwogRQKXwkPmJsQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_5c9183433e3c84cfcb12330d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "The Goddard School of South Tampa",
      "poi_type": "Education",
      "poi_address": "2401 W Kennedy Blvd, Tampa, FL 33609, USA",
      "poi_short_description": "Clean, secure, well-organized preschool featuring spacious classrooms, an indoor gym and an outdoor turf play area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-cc54-76da-a827-60a5ca422388.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-cc54-76da-a827-60a5ca422388",
        "storage_key": "property/6767906449167728/01a0353b-cc54-76da-a827-60a5ca422388.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/fl/tampa/south-tampa?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=712690935762965261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-south-tampa",
      "poi_latitude": "27.945",
      "poi_longitude": "-82.4842",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-665-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMUWrqNjDwogRDdPKTKH84wk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_3a004e8c96d7563409bba5fe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Hyde Park Day School",
      "poi_type": "Education",
      "poi_address": "909 W Horatio St, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://seaborndayschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6024495020244224129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyde-park-day-school",
      "poi_latitude": "27.9400126",
      "poi_longitude": "-82.46924179999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-251-8173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdXhbXZvEwogRgUjEQE1Om1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_e1fd88687778325ad2a0f527",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Montessori Children's House of Hyde Park",
      "poi_type": "Education",
      "poi_address": "2416 W Cleveland St, Tampa, FL 33609, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-cdc9-763e-b460-59cd48342ca3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-cdc9-763e-b460-59cd48342ca3",
        "storage_key": "property/6767906449167728/01a0353b-cdc9-763e-b460-59cd48342ca3.webp",
        "width": 1024,
        "height": 765
      },
      "poi_business_url": "https://www.cdstampabay.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18001100885191836946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montessori-childrens-house-of-hyde-park",
      "poi_latitude": "27.9431163",
      "poi_longitude": "-82.4847724",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-354-9511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuVO-u3rDwogREkXUk-HB0Pk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_fa040e4af15acaa9aa808749",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "CMX CinéBistro at Hyde Park Village",
      "poi_type": "Entertainment",
      "poi_address": "1609 W Swann Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Upscale cinema chain serving bistro food, popcorn & cocktails during film screenings.",
      "poi_long_description": "Upscale cinema chain serving bistro food, popcorn & cocktails during film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-ce48-767f-8660-8ed253aefc34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-ce48-767f-8660-8ed253aefc34",
        "storage_key": "property/6767906449167728/01a0353b-ce48-767f-8660-8ed253aefc34.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cmxcinemas.com/Showtimes/Cinebistro--Hyde-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17951356562144872523&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cmx-cinbistro-at-hyde-park-village",
      "poi_latitude": "27.9377419",
      "poi_longitude": "-82.4764423",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-514-8310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e3f-72bb-aa43-49804f569f83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e3f-72bb-aa43-49804f569f83",
        "storage_key": "property/6767906449167728/01a0353c-0e3f-72bb-aa43-49804f569f83.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQkta2LDwogRS8gF064HIPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_e974bc5b93dfac1b4cd3d717",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "MacDinton's Irish Pub",
      "poi_type": "Restaurants",
      "poi_address": "405 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Irish chow, live music & sports draw crowds at this convivial pub with an outdoor patio.",
      "poi_long_description": "Irish chow, live music & sports draw crowds at this convivial pub with an outdoor patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-cea1-745b-ae68-349aa5983c17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-cea1-745b-ae68-349aa5983c17",
        "storage_key": "property/6767906449167728/01a0353b-cea1-745b-ae68-349aa5983c17.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://macdintons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2075244391717229541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macdintons-irish-pub",
      "poi_latitude": "27.9405322",
      "poi_longitude": "-82.48318139999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-251-8999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e67-7296-ab71-5a0066b3164e",
        "storage_key": "property/6767906449167728/01a03539-4e67-7296-ab71-5a0066b3164e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTSQO5GTDwogR5VNtdse_zBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_pub"
    },
    {
      "id": "ec_f42f77899186c992c1621639",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Tampa Theatre",
      "poi_type": "Entertainment",
      "poi_address": "711 N Franklin St, Tampa, FL 33602, USA",
      "poi_short_description": "Built in 1926, this ornate movie palace features a Wurlitzer organ plus films, shows & other events.",
      "poi_long_description": "Built in 1926, this ornate movie palace features a Wurlitzer organ plus films, shows & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-d240-7148-8e18-24cc9dc1f4fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-d240-7148-8e18-24cc9dc1f4fd",
        "storage_key": "property/6767906449167728/01a0353b-d240-7148-8e18-24cc9dc1f4fd.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.tampatheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13247868558926946431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-theatre",
      "poi_latitude": "27.9503523",
      "poi_longitude": "-82.4589293",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-274-8286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e3f-72bb-aa43-49804f569f83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e3f-72bb-aa43-49804f569f83",
        "storage_key": "property/6767906449167728/01a0353c-0e3f-72bb-aa43-49804f569f83.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98cKiInEwogRfyDonUPi2bc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_50188b04fe7f91c3b1fadfd8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Tampa Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "120 W Gasparilla Plaza, Tampa, FL 33602, USA",
      "poi_short_description": "Waterfront space with translucent ceilings & polished stone floors housing modern & classical art.",
      "poi_long_description": "Waterfront space with translucent ceilings & polished stone floors housing modern & classical art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-d203-77ea-b64f-039385e440fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-d203-77ea-b64f-039385e440fb",
        "storage_key": "property/6767906449167728/01a0353b-d203-77ea-b64f-039385e440fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tampamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14070563233475260026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-museum-of-art",
      "poi_latitude": "27.9494852",
      "poi_longitude": "-82.4629535",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-274-8130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e41-7658-a0be-d080c14b22c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e41-7658-a0be-d080c14b22c4",
        "storage_key": "property/6767906449167728/01a0353c-0e41-7658-a0be-d080c14b22c4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy6ESWITDwogReu72OLauRMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_c3fe773cab1faf18c9082e2c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "The Florida Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "701 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Aquarium with sharks, penguins, stingray touch tanks, a wild dolphin cruise & a water playground.",
      "poi_long_description": "Aquarium with sharks, penguins, stingray touch tanks, a wild dolphin cruise & a water playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-2349-75bd-8ed3-2a514097fb26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03539-2349-75bd-8ed3-2a514097fb26",
        "storage_key": "property/6767906449167728/01a03539-2349-75bd-8ed3-2a514097fb26.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15088866459868476301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-florida-aquarium",
      "poi_latitude": "27.943972",
      "poi_longitude": "-82.44487470000001",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-273-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e6d-77ff-a62f-68fc4853835e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e6d-77ff-a62f-68fc4853835e",
        "storage_key": "property/6767906449167728/01a03539-4e6d-77ff-a62f-68fc4853835e.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJCXAq5_DEwogRjTPE2xlsZtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_b20ee339a75733ef0b1489af",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Straz Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1010 N WC Macinnes Pl, Tampa, FL 33602, USA",
      "poi_short_description": "Spacious venue featuring a 4,327-seat space for dance, theater & opera performances.",
      "poi_long_description": "Spacious venue featuring a 4,327-seat space for dance, theater & opera performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-d406-7629-92fe-1929084faea2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-d406-7629-92fe-1929084faea2",
        "storage_key": "property/6767906449167728/01a0353b-d406-7629-92fe-1929084faea2.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.strazcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6331971547108004456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "straz-center-for-the-performing-arts",
      "poi_latitude": "27.9516604",
      "poi_longitude": "-82.4640622",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-229-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJce6XFIjEwogRaNJA6ZKu31c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_7e7833a17ff2b22023527713",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Benchmark International Arena",
      "poi_type": "Entertainment",
      "poi_address": "401 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Huge, snazzy indoor venue hosting pro hockey & arena-football games, plus concerts & more.",
      "poi_long_description": "Huge, snazzy indoor venue hosting pro hockey & arena-football games, plus concerts & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-28dd-77aa-bf5a-b75e9c760010.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03539-28dd-77aa-bf5a-b75e9c760010",
        "storage_key": "property/6767906449167728/01a03539-28dd-77aa-bf5a-b75e9c760010.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.benchmarkintlarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3143982047536201843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benchmark-international-arena",
      "poi_latitude": "27.9427373",
      "poi_longitude": "-82.4517771",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-301-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSV2_Mo3EwogRc8CZwwOroSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_160b1345a4be4b9ae073cdae",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Tampa General Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Tampa General Cir, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-304b-727d-9faf-7f8331395895.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03539-304b-727d-9faf-7f8331395895",
        "storage_key": "property/6767906449167728/01a03539-304b-727d-9faf-7f8331395895.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tgh.org/?utm_source=ExtNet&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=13864056167954562457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-general-hospital",
      "poi_latitude": "27.9377069",
      "poi_longitude": "-82.45921299999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-844-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4eb6-718b-9a8b-fd2e70cf0f2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4eb6-718b-9a8b-fd2e70cf0f2f",
        "storage_key": "property/6767906449167728/01a03539-4eb6-718b-9a8b-fd2e70cf0f2f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJW92V1ZPEwogRmb3-PKEFZ8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_5e7d903a33fc135b3017e880",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "South Tampa Immediate Care",
      "poi_type": "Health and Wellness",
      "poi_address": "602 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-db70-76f9-bde9-215e907fc9f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-db70-76f9-bde9-215e907fc9f3",
        "storage_key": "property/6767906449167728/01a0353b-db70-76f9-bde9-215e907fc9f3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.southtampaimmediatecare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4367095167657998280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-tampa-immediate-care",
      "poi_latitude": "27.9384282",
      "poi_longitude": "-82.48285589999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-253-2113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFeUzTmTDwogRyHeUyOoJmzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_9dfac6423de31a94f0534ddc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Davis Islands Pharmacy & Compounding Lab",
      "poi_type": "Health and Wellness",
      "poi_address": "232 E Davis Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-ddbe-761f-8cfd-d66b61efe54e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-ddbe-761f-8cfd-d66b61efe54e",
        "storage_key": "property/6767906449167728/01a0353b-ddbe-761f-8cfd-d66b61efe54e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://davisislandspharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12963325283652998659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "davis-islands-pharmacy--compounding-lab",
      "poi_latitude": "27.926565",
      "poi_longitude": "-82.453662",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-254-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e40-729e-a03c-6dac119c3bec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e40-729e-a03c-6dac119c3bec",
        "storage_key": "property/6767906449167728/01a0353c-0e40-729e-a03c-6dac119c3bec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGSKfh7_EwogRAxb6r6n75rM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_2f2aad06dfd0931d323f0394",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "TGH Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Davis Blvd Ste 300, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tgh.org/fitness-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17416158169138059696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tgh-fitness-center",
      "poi_latitude": "27.9364954",
      "poi_longitude": "-82.4595437",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUcwxHgDFwogRsNl9f5SfsvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_f9cd9d2111c2e9d8c59ea33f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "940 S Howard Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Chain studio specializing in Pilates classes, including beginner options, with free parking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-d641-76da-a89f-b446031bf569.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-d641-76da-a89f-b446031bf569",
        "storage_key": "property/6767906449167728/01a0353b-d641-76da-a89f-b446031bf569.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/southtampa?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=4610081378919886221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "27.9340597",
      "poi_longitude": "-82.4829108",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-607-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ622p8GbDwogRja0pwJZM-j8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_130571ce1a3d2991d0dbaff0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "JETSET Pilates - South Tampa",
      "poi_type": "Health and Wellness",
      "poi_address": "1413 S Howard Ave Ste 104, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-dabd-732d-aa96-8f345b17b2a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-dabd-732d-aa96-8f345b17b2a0",
        "storage_key": "property/6767906449167728/01a0353b-dabd-732d-aa96-8f345b17b2a0.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://jetsetpilates.com/fl/south-tampa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1181001564035305894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jetset-pilates---south-tampa",
      "poi_latitude": "27.9284513",
      "poi_longitude": "-82.4838628",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-587-2313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ9xHdPzDwogRplGBT6rCYxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_23863e9fa01be16834b36f77",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Pure Strength & Movement",
      "poi_type": "Health and Wellness",
      "poi_address": "2201 W Swann Ave Ste 200B, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-d851-77fb-ae7c-e980af42f419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-d851-77fb-ae7c-e980af42f419",
        "storage_key": "property/6767906449167728/01a0353b-d851-77fb-ae7c-e980af42f419.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://puresouthtampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11976213167903710429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-strength--movement",
      "poi_latitude": "27.9376242",
      "poi_longitude": "-82.48217129999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 724-513-1318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYiWDwfdwogR3ZxBa2wONKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_fc9c4d6cd40fde5e0511522f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Soho Fit",
      "poi_type": "Health and Wellness",
      "poi_address": "715 S Howard Ave Unit 130, Tampa, FL 33606, USA",
      "poi_short_description": "Exclusive fitness center with 1-on-1 instruction and customizable workout plans for gym members, plus golf lessons.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-d6c4-7594-a624-bf2675024692.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-d6c4-7594-a624-bf2675024692",
        "storage_key": "property/6767906449167728/01a0353b-d6c4-7594-a624-bf2675024692.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://sohofittampa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12470030155963441368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soho-fit",
      "poi_latitude": "27.9363034",
      "poi_longitude": "-82.4833347",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-586-0760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWiz5jXDwogR2CCcmFtyDq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ee37b372b1d408ae53418057",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "CrossFit Hyde Park",
      "poi_type": "Health and Wellness",
      "poi_address": "1335 W Gray St, Tampa, FL 33606, USA",
      "poi_short_description": "CrossFit box featuring classes and weightlifting in a clean facility.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-dbd4-717e-a37b-4ee921ae912b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-dbd4-717e-a37b-4ee921ae912b",
        "storage_key": "property/6767906449167728/01a0353b-dbd4-717e-a37b-4ee921ae912b.webp",
        "width": 1170,
        "height": 1154
      },
      "poi_business_url": "https://crossfithydepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3151504386554650424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-hyde-park",
      "poi_latitude": "27.94857",
      "poi_longitude": "-82.47379500000001",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 813-791-7793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYYcL9GXDwogRON-szIpkvCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_a5a8382f36379e23e14ee0c9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Bayshore Fitness Trail",
      "poi_type": "Health and Wellness",
      "poi_address": "Tampa, FL 33606, USA",
      "poi_short_description": "Popular coastal path for biking, rollerblading and jogging, plus fitness stations.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-e0fd-760b-a3e6-cfff407c8626.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-e0fd-760b-a3e6-cfff407c8626",
        "storage_key": "property/6767906449167728/01a0353b-e0fd-760b-a3e6-cfff407c8626.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tampa.gov/parks-and-recreation/programs/parks-and-facilities/greenways-and-trails/trail-maps/bayshore-trail",
      "poi_directions_map_url": "https://maps.google.com/?cid=15793340734367579659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayshore-fitness-trail",
      "poi_latitude": "27.9358616",
      "poi_longitude": "-82.4667664",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0V9psTFwogRC76voLg3Lds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_2388a0df6e169f7498369f9e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Fred Ball Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2621 Bayshore Blvd, Tampa, FL 33629, USA",
      "poi_short_description": "Small dog-friendly green park overlooking the bay with a gazebo, tennis court & parking lot.",
      "poi_long_description": "Small dog-friendly green park overlooking the bay with a gazebo, tennis court & parking lot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-f3a3-725d-8bcb-58d61e4ce591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-f3a3-725d-8bcb-58d61e4ce591",
        "storage_key": "property/6767906449167728/01a0353b-f3a3-725d-8bcb-58d61e4ce591.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://tampagov.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1920725329059583977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-ball-park",
      "poi_latitude": "27.9223944",
      "poi_longitude": "-82.48855669999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-274-8615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4ead-724f-9a70-93eaef1b6384",
        "storage_key": "property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnS5A_0TDwogR6RexpYLJpxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_70854d735023e70282f5c6c1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Tony Jannus Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-e929-7162-b962-1ba7b950ab8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-e929-7162-b962-1ba7b950ab8f",
        "storage_key": "property/6767906449167728/01a0353b-e929-7162-b962-1ba7b950ab8f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2832081184394938218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tony-jannus-park",
      "poi_latitude": "27.9424573",
      "poi_longitude": "-82.4594922",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4ead-724f-9a70-93eaef1b6384",
        "storage_key": "property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zKnR1nFwogRaoftCtWSTSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d4e10e97f8ab5ba66c2cb164",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Columbus Statue Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Bayshore Blvd, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-e0ae-7367-92bc-d809652cc8c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-e0ae-7367-92bc-d809652cc8c3",
        "storage_key": "property/6767906449167728/01a0353b-e0ae-7367-92bc-d809652cc8c3.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=560843359604636262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbus-statue-park",
      "poi_latitude": "27.9411407",
      "poi_longitude": "-82.4593915",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-832-1228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4ead-724f-9a70-93eaef1b6384",
        "storage_key": "property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT1HFA47EwogRZvreZxCEyAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_89e38883092a4c0626a455d1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "\"Spanishtown Creek\" Marker",
      "poi_type": "Entertainment",
      "poi_address": "W Bay St, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.hmdb.org/m.asp?m=69853",
      "poi_directions_map_url": "https://maps.google.com/?cid=6895498991036322779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spanishtown-creek-marker",
      "poi_latitude": "27.9379424",
      "poi_longitude": "-82.46454630000001",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e5d-7535-b9be-274f89dcb89a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e5d-7535-b9be-274f89dcb89a",
        "storage_key": "property/6767906449167728/01a0353c-0e5d-7535-b9be-274f89dcb89a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSVgrJwDFwogR29PIZcy7sV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "ec_dabadedc1254d102c3b859a6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Hyde Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "702 S Albany Ave, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-f36c-7494-988a-792959e16770.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-f36c-7494-988a-792959e16770",
        "storage_key": "property/6767906449167728/01a0353b-f36c-7494-988a-792959e16770.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://www.tampa.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15805958286142728516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyde-park",
      "poi_latitude": "27.9361952",
      "poi_longitude": "-82.4807494",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 813-274-8615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4ead-724f-9a70-93eaef1b6384",
        "storage_key": "property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw3CjqmbDwogRROktVFELWts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_2e5c537ca8f3788badb5d417",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Anderson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "802 S Rome Ave, Tampa, FL 33606, USA",
      "poi_short_description": "Laid-back playground and garden for kids, with a splash pad and basketball courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-f36c-7494-988a-76cabfe54b99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-f36c-7494-988a-76cabfe54b99",
        "storage_key": "property/6767906449167728/01a0353b-f36c-7494-988a-76cabfe54b99.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.tampagov.net/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=18195506720639013668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anderson-park",
      "poi_latitude": "27.9339327",
      "poi_longitude": "-82.4772354",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 813-259-1608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4ead-724f-9a70-93eaef1b6384",
        "storage_key": "property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRaFQ0CTDwogRJNPrX_Vsg_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2dc141a6adc7f6ed86ce6eb7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Davis Islands Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "155 Columbia Dr, Tampa, FL 33606, USA",
      "poi_short_description": "Park with baseball and softball fields, plus a playground, basketball court, and picnic areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-f85f-760c-bef8-402fd7326a47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-f85f-760c-bef8-402fd7326a47",
        "storage_key": "property/6767906449167728/01a0353b-f85f-760c-bef8-402fd7326a47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tampagov.net/parks-and-recreation/parks-and-facilities/playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=11750450211144617683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "davis-islands-park",
      "poi_latitude": "27.9288557",
      "poi_longitude": "-82.45337289999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 813-274-7716",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4ead-724f-9a70-93eaef1b6384",
        "storage_key": "property/6767906449167728/01a03539-4ead-724f-9a70-93eaef1b6384.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRxLV5XEwogR004w4jX8EaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5609c6d626b4597b015f3154",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Marjorie Park Yacht Basin",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "115 Columbia Dr, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-e8d7-7539-ae7b-e6c8c1ec2ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-e8d7-7539-ae7b-e6c8c1ec2ee5",
        "storage_key": "property/6767906449167728/01a0353b-e8d7-7539-ae7b-e6c8c1ec2ee5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tampagov.net/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=11343309367574949301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marjorie-park-yacht-basin",
      "poi_latitude": "27.9333209",
      "poi_longitude": "-82.45565119999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-259-1604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_eGpk5TEwogRtW2qN8WHa50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_5462cfd6c8b6564e05fb2040",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Tampa International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "4100 George J. Bean Pkwy, Tampa, FL 33607, USA",
      "poi_short_description": "Large airport with free WiFi, an on-site hotel & many offshoots of popular Tampa restaurants.",
      "poi_long_description": "Large airport with free WiFi, an on-site hotel & many offshoots of popular Tampa restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-39f6-77c9-b7f0-9863fe9e8754.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03539-39f6-77c9-b7f0-9863fe9e8754",
        "storage_key": "property/6767906449167728/01a03539-39f6-77c9-b7f0-9863fe9e8754.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tampaairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8816785868724491529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-international-airport",
      "poi_latitude": "27.9768646",
      "poi_longitude": "-82.5302804",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 813-870-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e59-74f3-9fad-f10f4840034c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e59-74f3-9fad-f10f4840034c",
        "storage_key": "property/6767906449167728/01a03539-4e59-74f3-9fad-f10f4840034c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0Sek0bCwogRCdUBxgiEW3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_793068ad4e21b405d44c9a58",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Peter O. Knight Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "825 Severn Ave, Tampa, FL 33606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-3d16-7447-99ba-86a5385a9a93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03539-3d16-7447-99ba-86a5385a9a93",
        "storage_key": "property/6767906449167728/01a03539-3d16-7447-99ba-86a5385a9a93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tampaairport.com/peter-o-knight-airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=12582221839458516165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peter-o-knight-airport",
      "poi_latitude": "27.9122373",
      "poi_longitude": "-82.449926",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 813-251-1752",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e59-74f3-9fad-f10f4840034c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e59-74f3-9fad-f10f4840034c",
        "storage_key": "property/6767906449167728/01a03539-4e59-74f3-9fad-f10f4840034c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJtfZMuvXEwogRxTwWehkIna4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_8e6154069fda0d9d409e4fa4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Amtrak",
      "poi_type": "Transportation & Transit",
      "poi_address": "601 N Nebraska Ave, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-f85f-760c-bef8-46cf1a14ad11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-f85f-760c-bef8-46cf1a14ad11",
        "storage_key": "property/6767906449167728/01a0353b-f85f-760c-bef8-46cf1a14ad11.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/stations/tpa",
      "poi_directions_map_url": "https://maps.google.com/?cid=11680206783434409790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak",
      "poi_latitude": "27.9526866",
      "poi_longitude": "-82.45065249999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 833-844-0830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWlYhl_EwogRPke3ZS9uGKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_86337afd0606e1c0ffbcbf29",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Marion Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1211 N Marion St, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-f990-7210-8fb6-e23dce375308.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-f990-7210-8fb6-e23dce375308",
        "storage_key": "property/6767906449167728/01a0353b-f990-7210-8fb6-e23dce375308.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gohart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12356063461840094640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marion-transit-center",
      "poi_latitude": "27.95561",
      "poi_longitude": "-82.45827",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-254-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e98-772b-a5ea-110a95b51e4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e98-772b-a5ea-110a95b51e4b",
        "storage_key": "property/6767906449167728/01a0353c-0e98-772b-a5ea-110a95b51e4b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7X6-i2HEwogRsIUp2UCOeas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_9d5608fb32bc96232be5570a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Dick Greco Plaza Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-f471-7344-a74f-26bdffaca9f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-f471-7344-a74f-26bdffaca9f9",
        "storage_key": "property/6767906449167728/01a0353b-f471-7344-a74f-26bdffaca9f9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5364926643300246030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dick-greco-plaza-station",
      "poi_latitude": "27.9415784",
      "poi_longitude": "-82.45481269999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-5200-7098-8288-25c5bfede3f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-5200-7098-8288-25c5bfede3f9",
        "storage_key": "property/6767906449167728/01a03539-5200-7098-8288-25c5bfede3f9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsVftQo3EwogRDqLwg1sMdEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_bb3475b1950d9b893f03ed5b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "The Florida Aquarium Station #7",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-f859-7355-b293-2537f4b1a8fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-f859-7355-b293-2537f4b1a8fc",
        "storage_key": "property/6767906449167728/01a0353b-f859-7355-b293-2537f4b1a8fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4110317896266080304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-florida-aquarium-station-7",
      "poi_latitude": "27.9457511",
      "poi_longitude": "-82.4456034",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-5200-7098-8288-25c5bfede3f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-5200-7098-8288-25c5bfede3f9",
        "storage_key": "property/6767906449167728/01a03539-5200-7098-8288-25c5bfede3f9.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQdGP1fDEwogRMODeaFnICjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_8bd55265fd8be1eff97f1587",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Port Tampa Bay",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1101 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "Departure point for local & Caribbean cruises, plus educational boat tours of the harbor.",
      "poi_long_description": "Departure point for local & Caribbean cruises, plus educational boat tours of the harbor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353b-fd8c-730a-9021-793f771be3c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353b-fd8c-730a-9021-793f771be3c0",
        "storage_key": "property/6767906449167728/01a0353b-fd8c-730a-9021-793f771be3c0.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://porttb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8691922585219425657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-tampa-bay",
      "poi_latitude": "27.9503837",
      "poi_longitude": "-82.4450219",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 813-905-7678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-521b-77e3-a831-660feddfe326.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-521b-77e3-a831-660feddfe326",
        "storage_key": "property/6767906449167728/01a03539-521b-77e3-a831-660feddfe326.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV8JZy_fEwogReeUyG4rpn3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_9931fc4053ffe03248fcfac6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Britton Plaza Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tampa, FL 33611, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-01bf-7644-8b86-19468e37e60e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353c-01bf-7644-8b86-19468e37e60e",
        "storage_key": "property/6767906449167728/01a0353c-01bf-7644-8b86-19468e37e60e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6037919262098796039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "britton-plaza-station",
      "poi_latitude": "27.90682",
      "poi_longitude": "-82.50417999999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e40-729e-a03c-698a3feccc40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e40-729e-a03c-698a3feccc40",
        "storage_key": "property/6767906449167728/01a0353c-0e40-729e-a03c-698a3feccc40.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eSp6czcwogRBy7jH5T_ylM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_6edabd65e07068e88ab05241",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "West Tampa Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tampa, FL 33607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18132250933078481478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-tampa-transfer-center",
      "poi_latitude": "27.97771",
      "poi_longitude": "-82.50097",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e40-729e-a03c-698a3feccc40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e40-729e-a03c-698a3feccc40",
        "storage_key": "property/6767906449167728/01a0353c-0e40-729e-a03c-698a3feccc40.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ00_zXb_DwogRRlpjpCeyovs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_8b89fdc4269769730d3b6f4c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Netpark Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4948 N 56th St, Tampa, FL 33619, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-00c2-70d7-8de9-8d4fd1243ae8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353c-00c2-70d7-8de9-8d4fd1243ae8",
        "storage_key": "property/6767906449167728/01a0353c-00c2-70d7-8de9-8d4fd1243ae8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7756711966683944594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "netpark-transfer-center",
      "poi_latitude": "27.9900104",
      "poi_longitude": "-82.391252",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 813-254-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0e53-700f-a239-3f27fe18f82e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0353c-0e53-700f-a239-3f27fe18f82e",
        "storage_key": "property/6767906449167728/01a0353c-0e53-700f-a239-3f27fe18f82e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJsfcfNfnFwogRktY3129gpWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_f05f24b09a061b8b706e115d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Moffitt Magnolia Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "12902 USF Magnolia Drive, Tampa, FL 33612, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-01cb-75cd-ae59-305f48051daf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353c-01cb-75cd-ae59-305f48051daf",
        "storage_key": "property/6767906449167728/01a0353c-01cb-75cd-ae59-305f48051daf.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://moffitt.org/locations-directions/moffitt-cancer-center-on-magnolia-usf/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2336389287961145418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moffitt-magnolia-campus",
      "poi_latitude": "28.0641043",
      "poi_longitude": "-82.4210208",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 888-663-3488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e77-7638-a632-261e8e1ad85c",
        "storage_key": "property/6767906449167728/01a03539-4e77-7638-a632-261e8e1ad85c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZTF16LHwogRSrDzva2FbCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_6fad2e9b65126ad30653ee38",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "MacDill Base Legal Office",
      "poi_type": "Transportation & Transit",
      "poi_address": "MacDill AFB, 8208 Hangar Loop Dr, Tampa, FL 33621, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-041c-73cc-b545-5ed3a9b84413.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353c-041c-73cc-b545-5ed3a9b84413",
        "storage_key": "property/6767906449167728/01a0353c-041c-73cc-b545-5ed3a9b84413.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://aflegalassistance.law.af.mil/apps/aflass_public/bin/main.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=15410932557452226345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macdill-base-legal-office",
      "poi_latitude": "27.8497201",
      "poi_longitude": "-82.4872077",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 813-828-4421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-521b-77e3-a831-660feddfe326.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-521b-77e3-a831-660feddfe326",
        "storage_key": "property/6767906449167728/01a03539-521b-77e3-a831-660feddfe326.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3fwIiW_cwogRKS9xqIKh3tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_f2a59a5b0eb60a0b764b5426",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "USF Health Morsani College of Medicine",
      "poi_type": "Education",
      "poi_address": "560 Channelside Dr, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-021a-72db-9fa9-0236a47bcfc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353c-021a-72db-9fa9-0236a47bcfc5",
        "storage_key": "property/6767906449167728/01a0353c-021a-72db-9fa9-0236a47bcfc5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://health.usf.edu/medicine",
      "poi_directions_map_url": "https://maps.google.com/?cid=14912303864288018356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usf-health-morsani-college-of-medicine",
      "poi_latitude": "27.9437621",
      "poi_longitude": "-82.449423",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 813-396-9459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4e5a-7272-934e-1e3cb6545781",
        "storage_key": "property/6767906449167728/01a03539-4e5a-7272-934e-1e3cb6545781.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQcd_WqLHwogRtH-SFVsl884",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_328f36111f32848c9969c755",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "James A. Haley Veterans' Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "13000 Bruce B Downs Blvd, Tampa, FL 33612, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-061f-7343-95f3-65c67cb37ea2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353c-061f-7343-95f3-65c67cb37ea2",
        "storage_key": "property/6767906449167728/01a0353c-061f-7343-95f3-65c67cb37ea2.webp",
        "width": 1280,
        "height": 1117
      },
      "poi_business_url": "https://www.va.gov/tampa-health-care/locations/james-a-haley-veterans-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5577032833284040040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-a-haley-veterans-hospital",
      "poi_latitude": "28.0644878",
      "poi_longitude": "-82.42916489999999",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 813-972-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-4eb6-718b-9a8b-fd2e70cf0f2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-4eb6-718b-9a8b-fd2e70cf0f2f",
        "storage_key": "property/6767906449167728/01a03539-4eb6-718b-9a8b-fd2e70cf0f2f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZIwdaHHwogRaOWVQNCZZU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_4a024a84137876274a26b712",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Tampa City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "E Kennedy Blvd, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-41da-73ff-8498-cebb01b18063.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03539-41da-73ff-8498-cebb01b18063",
        "storage_key": "property/6767906449167728/01a03539-41da-73ff-8498-cebb01b18063.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tampa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8929066317482268098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tampa-city-hall",
      "poi_latitude": "27.9477268",
      "poi_longitude": "-82.4572693",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-274-8211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-521b-77e3-a831-660feddfe326.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-521b-77e3-a831-660feddfe326",
        "storage_key": "property/6767906449167728/01a03539-521b-77e3-a831-660feddfe326.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyeS5lovEwogRwpVv7YFq6ns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_27efbd3f45e6df4fccbf5e38",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "poi_name": "Hillsborough County Tax Collector",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 E Kennedy Blvd, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a0353c-0611-726a-8099-6207de0d18cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0353c-0611-726a-8099-6207de0d18cc",
        "storage_key": "property/6767906449167728/01a0353c-0611-726a-8099-6207de0d18cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hillstaxfl.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2993346978512072366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsborough-county-tax-collector",
      "poi_latitude": "27.948334",
      "poi_longitude": "-82.45476599999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 813-635-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167728/01a03539-521b-77e3-a831-660feddfe326.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03539-521b-77e3-a831-660feddfe326",
        "storage_key": "property/6767906449167728/01a03539-521b-77e3-a831-660feddfe326.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbrlKovEwogRrm6zrzeBiik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8b993944866d48e70e5e0501",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b067ea9fd6cbf6242d1a7b33",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_91eb8603e0da4fffa78eddbe",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_24567b6eedf9d5381e61b307",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_dee81603c37a963d343767db",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9f95e8bd817140922f0bbfb7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_b359d9db6d99bd981445f881",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "rating": "5",
      "name": "Rishab36",
      "text": "Christopher has been absolutely amazing to work with. He recently helped us fix our heating, water heater, and coolers, including replacing the pads, and everything was handled quickly and efficiently.\n\nWhether it’s the sink or anything else, he’s always there and ready to help.\n\nHe’s also very friendly, easy to talk to, and makes everything feel comfortable and stress-free.\n\nI would highly recommend him.",
      "date": "2026-03-19",
      "title": "false"
    },
    {
      "id": "ec_d636b5c84d91b79ce32faace",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "rating": "5",
      "name": "gabby miller",
      "text": "Christopher who helps with maintenance always comes with a smile on his face and always willing to help. Also gives us tips on how to avoid the problems we have in our apartment complex. Really great and also took out our trash which was NOT NECESSARY. Great staff at MAA 👏🏻🎉",
      "date": "2026-01-26",
      "title": "false"
    },
    {
      "id": "ec_8f290856b4385710060cb621",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "rating": "4",
      "name": "sneakers",
      "text": "Great place to live, attentive and communicative front office staff.  However, it is difficult and stressful to secure an apartment, I’m not sure how they would reconcile this but it can be difficult to feel secured in having a place to live while applying. An option for advanced pay to secure would be nice. Also, not that this would sway my decision but the pool chairs are so beyond uncomfortable, hot and hard to sit on with an unheated pool. Otherwise great, just think about if you have the time and patience to feel a little insecure in your next move until the application has hit!",
      "date": "2026-04-23",
      "title": "false"
    },
    {
      "id": "ec_c6d903084ce35f32b34a65c1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "rating": "5",
      "name": "Molly Brennan",
      "text": "Christopher on the maintenance team  is the best! He’s always incredibly kind, efficient, and professional. Any time he comes to work in my apartment at MAA Hyde Park, he makes sure we’re comfortable and explains what he’s doing. He gets things done quickly and the right way. Truly appreciate him helping us over this year with anything we needed.",
      "date": "2026-01-27",
      "title": "false"
    },
    {
      "id": "ec_360a46575e3bb2c7594fa02b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "rating": "5",
      "name": "Jake Byrd",
      "text": "I’ve enjoyed living here for 2 years now. Great staff and maintenance team. The place is always clean and the pool looks amazing year round. Christopher is great on the maintenance team and always helpful!",
      "date": "2026-02-17",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-tampa-fl-blue-haven",
      "search_query": "dog-friendly apartments Tampa FL",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Tampa, FL",
      "h2_subtitle": "Explore our dog-friendly community in Tampa, FL. Discover no breed restrictions at Blue Haven, located in Hyde Park.",
      "page_copy": "Searching for dog-friendly apartments in Tampa, FL? Welcome to Blue Haven, where pets are celebrated as part of our community. Nestled in the charming Hyde Park neighborhood, our residences boast amenities designed with both you and your furry friends in mind. From spacious living areas to serene walkways, there’s ample room for play and relaxation.\n\nAt Blue Haven, we take pride in offering no breed restrictions, ensuring every dog has a chance to call us home. Our property features a convenient picnic area, perfect for enjoying sunny afternoons together. Plus, with a one-car garage available, you and your pet can explore Tampa with ease. Experience welcoming and adaptable living at Blue Haven today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Tampa, FL",
      "seo_description": "Discover dog-friendly apartments in Tampa, FL at Blue Haven. Enjoy no breed restrictions and pet-friendly amenities in the heart of Hyde Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pools-hyde-park-blue-haven",
      "search_query": "luxury apartments with pools Hyde Park",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pools in Hyde Park",
      "h2_subtitle": "Discover elegance at our luxury apartments with pools in Hyde Park. Blue Haven offers premier amenities in the heart of Tampa.",
      "page_copy": "If you're seeking luxury apartments with pools in Hyde Park, Blue Haven is your ideal destination. Our community perfectly blends sophistication and comfort within the lively atmosphere of Hyde Park, offering an unparalleled living experience. While our pristine garden tubs provide a tranquil escape indoors, our inviting pools offer refreshing outdoor enjoyment.\n\nBeyond luxurious amenities, Blue Haven is renowned for its community-centric atmosphere. Residents benefit from a picnic area and free weights, perfect for socializing and staying active. Our pet-friendly policy, allowing all breeds, ensures that every member of your family is welcome. Whether you're lounging by the pool or enjoying the vibrant neighborhood, Blue Haven epitomizes upscale Tampa living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pools in Hyde Park",
      "seo_description": "Explore luxury apartments with pools in Hyde Park at Blue Haven. Enjoy upscale living with top-tier amenities in Tampa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-hillsborough-county-blue-haven",
      "search_query": "apartments with fitness center Hillsborough County",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Hillsborough",
      "h2_subtitle": "Stay active at our apartments with a fitness center in Hillsborough County. Blue Haven offers top amenities for a healthy lifestyle.",
      "page_copy": "Looking for apartments with fitness center access in Hillsborough County? Blue Haven is the perfect spot for those who value health and wellness. Nestled in the picturesque Hyde Park neighborhood, our community features a well-equipped fitness center complete with free weights. Residents can maintain their health goals without ever leaving home.\n\nBlue Haven stands out not just for its fitness amenities but also for its resident-friendly features like a one-car garage and a relaxing garden tub. We welcome pets of all breeds, ensuring everyone feels at home. Enjoy the vibrant lifestyle and convenient amenities that make Blue Haven a top choice in Hillsborough County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Hillsborough",
      "seo_description": "Find apartments with a fitness center in Hillsborough County at Blue Haven. Enjoy top amenities and a healthy lifestyle in Hyde Park, Tampa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-tampa-33606-blue-haven",
      "search_query": "in-unit laundry apartments Tampa 33606",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Tampa 33606",
      "h2_subtitle": "Discover the convenience of in-unit laundry apartments in Tampa's 33606 area. Experience modern living at Blue Haven in Hyde Park.",
      "page_copy": "For those in search of in-unit laundry apartments in Tampa's 33606 area, Blue Haven offers the ideal blend of convenience and comfort. Situated in the desirable Hyde Park neighborhood, our apartments provide modern amenities that enrich daily living. Say goodbye to laundromats and enjoy the ease of doing laundry in the privacy of your own home.\n\nAlongside in-unit laundry, Blue Haven boasts a variety of community features including a serene garden tub, a welcoming picnic area, and the assurance of no breed restrictions for pets. Our one-car garage and fitness amenities further complement your lifestyle. Blue Haven is the perfect place to call home for those seeking comfort and convenience in Tampa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Tampa 33606",
      "seo_description": "Discover in-unit laundry apartments in Tampa 33606 at Blue Haven. Enjoy modern amenities and a prime location in Hyde Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "pet-play-area-apartments-near-hyde-park-blue-haven",
      "search_query": "pet play area apartments near Hyde Park",
      "category": "Amenity",
      "h1_title": "Pet Play Area Apartments Near Hyde Park",
      "h2_subtitle": "Find your perfect home with a pet play area near Hyde Park. Blue Haven offers pet-friendly living in a vibrant community.",
      "page_copy": "Are you seeking pet play area apartments near Hyde Park? Discover Blue Haven, where pets are cherished members of the community. With no breed restrictions, we warmly welcome all furry friends to our supportive environment. Our location offers ample spaces for pets to frolic and enjoy outdoor activities.\n\nBeyond catering to your pets, Blue Haven offers residents luxurious amenities like a relaxing garden tub and a convenient one-car garage. Stay active with our free weights and unwind in our peaceful picnic area. Experience the perfect blend of pet-friendly living and upscale comforts at Blue Haven, nestled in the heart of Hyde Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Play Area Apartments Near Hyde Park",
      "seo_description": "Explore pet play area apartments near Hyde Park at Blue Haven. Enjoy pet-friendly living with no breed restrictions in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-hyde-park-tampa-blue-haven",
      "search_query": "two bedroom apartments in Hyde Park Tampa",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Hyde Park Tampa",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Hyde Park, Tampa. Blue Haven offers modern living with top amenities in a vibrant community.",
      "page_copy": "Looking for two-bedroom apartments in Hyde Park, Tampa? Blue Haven offers spacious layouts perfect for those needing extra room in a lively neighborhood. Our two-bedroom units provide an ideal balance of comfort and style, ensuring that every resident feels at home.\n\nLocated in the heart of Hyde Park, Blue Haven is equipped with exceptional amenities, including a garden tub for relaxation and a dedicated one-car garage. We also feature a picnic area and fitness options with free weights, making it easy to stay active. Embrace the vibrant community feel and modern conveniences at Blue Haven.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Hyde Park Tampa",
      "seo_description": "Explore two-bedroom apartments in Hyde Park, Tampa at Blue Haven. Enjoy spacious living in a vibrant community with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-hillsborough-county-blue-haven",
      "search_query": "three bedroom apartments Hillsborough County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Hillsborough County",
      "h2_subtitle": "Explore luxurious three-bedroom apartments in Hillsborough County. Blue Haven offers spacious living with modern amenities.",
      "page_copy": "Searching for three-bedroom apartments in Hillsborough County? Blue Haven provides the perfect solution with spacious units designed to suit families or individuals needing extra space. Our three-bedroom apartments are equipped with the finest amenities, ensuring both comfort and luxury.\n\nNestled in the charming Hyde Park area, Blue Haven offers convenient living with no breed restrictions for pets, and features like a garden tub and a one-car garage. Enjoy socializing in our picnic area or keeping fit with free weights. Blue Haven combines modern living with a welcoming community atmosphere in beautiful Hillsborough County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Hillsborough County",
      "seo_description": "Discover three-bedroom apartments in Hillsborough County at Blue Haven. Enjoy spacious, modern living in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-33606-blue-haven",
      "search_query": "one bedroom apartments near 33606",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near 33606",
      "h2_subtitle": "Find your perfect one-bedroom apartment near 33606. Blue Haven combines comfort with luxury in a prime location.",
      "page_copy": "Are you looking for one bedroom apartments near the 33606 area? Blue Haven is the place to be, offering stylish and comfortable living spaces in a prime location. Our one-bedroom apartments are perfect for individuals who appreciate quality and convenience.\n\nLocated near Hyde Park, Blue Haven provides residents with top-notch amenities like a rejuvenating garden tub, a private one-car garage, and a delightful picnic area. You'll also enjoy easy access to fitness options with our free weights. Experience luxury living in a vibrant community at Blue Haven, situated conveniently near the 33606 neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near 33606",
      "seo_description": "Explore one bedroom apartments near 33606 at Blue Haven. Experience luxury and comfort in a prime location with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-tampa-hyde-park-blue-haven",
      "search_query": "apartments near University of Tampa Hyde Park",
      "category": "School",
      "h1_title": "Apartments Near University of Tampa Hyde Park",
      "h2_subtitle": "Discover convenient living in apartments near the University of Tampa. Blue Haven offers premium options in the heart of Hyde Park.",
      "page_copy": "Looking for apartments near the University of Tampa in Hyde Park? Blue Haven provides an unbeatable location for students and professionals alike. Enjoy the convenience of being close to campus while living in a vibrant and stylish community.\n\nAt Blue Haven, you’ll find a welcoming atmosphere with great features such as a picnic area, a garden tub for relaxation, and a one-car garage for easy parking. We welcome all pets and have a fitness area complete with free weights. Enjoy the perfect blend of modern living and community charm right near the University of Tampa in beautiful Hyde Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Tampa Hyde Park",
      "seo_description": "Find apartments near the University of Tampa at Blue Haven. Enjoy modern amenities and a prime Hyde Park location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "apartments-near-hillsborough-college-dale-mabry-campus-fl-blue-haven",
      "search_query": "apartments near Hillsborough College Dale Mabry Campus FL",
      "category": "School",
      "h1_title": "Apartments Near Hillsborough College Dale Mabry",
      "h2_subtitle": "Explore top apartments near Hillsborough College Dale Mabry Campus. Blue Haven offers convenience and style in one package.",
      "page_copy": "Looking for the perfect apartment near Hillsborough College Dale Mabry Campus in FL? Blue Haven presents the ideal solution for students and staff seeking proximity and comfort. Nestled in the desirable Hyde Park neighborhood, our apartments offer an excellent combination of location and luxury.\n\nResidents at Blue Haven enjoy a range of amenities, including a refreshing garden tub, convenient one-car garage parking, and access to our fitness area with free weights. Whether you're relaxing in our picnic area or enjoying pet-friendly living with no breed restrictions, Blue Haven makes college life breezy and enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hillsborough College Dale Mabry",
      "seo_description": "Discover apartments near Hillsborough College Dale Mabry in FL at Blue Haven. Enjoy a prime location and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "apartments-near-st-josephs-hospital-tampa-blue-haven",
      "search_query": "apartments near St. Joseph's Hospital Tampa",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Joseph's Hospital Tampa",
      "h2_subtitle": "Find ideal living options close to St. Joseph's Hospital. Blue Haven offers modern apartments in a convenient Tampa location.",
      "page_copy": "Are you in search of apartments near St. Joseph's Hospital in Tampa? Look no further than Blue Haven, where comfort meets convenience. Perfectly situated in the vibrant Hyde Park neighborhood, our apartments ensure a quick commute to the hospital, whether you're a healthcare professional or visitor.\n\nBlue Haven is designed with your lifestyle in mind, offering amenities like a relaxing garden tub and a picnic area for outdoor enjoyment. Our one-car garages provide ease of parking, and fitness enthusiasts will appreciate our free weights. With no breed restrictions, Blue Haven is a welcoming home for all, just minutes from St. Joseph's Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Joseph's Hospital Tampa",
      "seo_description": "Explore apartments near St. Joseph's Hospital in Tampa at Blue Haven. Experience convenient living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "apartments-near-tampa-riverwalk-blue-haven",
      "search_query": "apartments near tampa riverwalk",
      "category": "Park",
      "h1_title": "Apartments Near Tampa Riverwalk",
      "h2_subtitle": "Experience stunning living options near Tampa Riverwalk. Blue Haven offers modern amenities in an ideal location.",
      "page_copy": "For those seeking the perfect blend of vibrant city life and tranquil living, Blue Haven provides exceptional apartments near Tampa Riverwalk. Nestled in the scenic Hyde Park neighborhood, our community is ideal for those who wish to enjoy the lively riverwalk and its numerous activities while residing in comfort.\n\nAt Blue Haven, residents benefit from a range of amenities such as a soothing garden tub and a relaxing picnic area. Fitness enthusiasts can enjoy the use of free weights, and with no breed restrictions, pets are always welcome. Our one-car garage options also add convenience, making Blue Haven an ideal choice near Tampa Riverwalk.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tampa Riverwalk",
      "seo_description": "Discover Blue Haven apartments near Tampa Riverwalk. Enjoy modern amenities and a prime location in the heart of the action.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "curtis-hixon-waterfront-park-nearby-apartments-tampa-blue-haven",
      "search_query": "curtis hixon waterfront park nearby apartments tampa",
      "category": "Park",
      "h1_title": "Curtis Hixon Waterfront Park Nearby Apartments",
      "h2_subtitle": "Discover beautiful apartments near Curtis Hixon Waterfront Park. Blue Haven offers proximity and comfort in Tampa.",
      "page_copy": "Imagine residing just a short distance from the bustling Curtis Hixon Waterfront Park, where vibrant city life meets serene waterfront views. Blue Haven provides exceptional nearby apartments right in the heart of Tampa, designed for those who appreciate both convenience and luxury.\n\nAt Blue Haven, you'll find amenities tailored for a comfortable lifestyle, including a relaxing garden tub and a charming picnic area perfect for outdoor gatherings. Fitness lovers will enjoy using our free weights, while our no breed restrictions policy ensures pets are part of the family. Plus, with a convenient one-car garage, our apartment community combines modern living with easy access to all that Curtis Hixon Waterfront Park has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Curtis Hixon Waterfront Park Nearby Apartments",
      "seo_description": "Find Blue Haven apartments near Curtis Hixon Waterfront Park in Tampa. Enjoy a convenient location and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "julian-b-lane-riverfront-park-hyde-park-location-apartments-blue-haven",
      "search_query": "julian b. lane riverfront park hyde park location apartments",
      "category": "Park",
      "h1_title": "Julian B. Lane Riverfront Park Apartments",
      "h2_subtitle": "Explore Hyde Park location apartments near Julian B. Lane Riverfront Park. Discover Blue Haven’s prime offerings.",
      "page_copy": "Nestled in the picturesque Hyde Park neighborhood, Blue Haven offers exquisite apartments just moments from Julian B. Lane Riverfront Park. This location provides the perfect setting for those who want to enjoy Tampa’s rich outdoor spaces while living in style and comfort.\n\nBlue Haven features a variety of amenities that cater to your needs. Enjoy a calming soak in our garden tub or unwind at our picnic area after a day at the park. With free weights available, fitness routines are easily maintained, and our no breed restrictions policy makes it a pet-friendly environment. Additionally, the convenience of a one-car garage makes Blue Haven a top choice for Hyde Park location apartments near Julian B. Lane Riverfront Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Julian B. Lane Riverfront Park Apartments",
      "seo_description": "Discover Blue Haven’s Hyde Park location apartments near Julian B. Lane Riverfront Park. Enjoy prime amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "apartments-near-tampa-international-airport-blue-haven",
      "search_query": "apartments near tampa international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Tampa International Airport",
      "h2_subtitle": "Find convenient living with apartments near Tampa International Airport. Discover Blue Haven's excellent amenities and location.",
      "page_copy": "Blue Haven offers ideal living options for those seeking apartments near Tampa International Airport. Located in the welcoming Hyde Park neighborhood, our community allows you to enjoy the best of Tampa while being just a short drive from the airport—perfect for frequent travelers.\n\nResidents of Blue Haven experience a blend of comfort and convenience with amenities such as a relaxing garden tub and a delightful picnic area. Fitness goals are easily achieved with access to free weights, and our no breed restrictions policy means your furry friends are welcome. A one-car garage adds even more convenience, making Blue Haven an invaluable choice for living near Tampa International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tampa International Airport",
      "seo_description": "Explore Blue Haven apartments near Tampa International Airport. Enjoy unparalleled convenience and amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "apartments-close-to-airport-maintenance-department-tampa-blue-haven",
      "search_query": "apartments close to airport maintenance department tampa",
      "category": "Transit",
      "h1_title": "Apartments Close to Airport Maintenance",
      "h2_subtitle": "Discover convenience with apartments close to the Airport Maintenance Department in Tampa. Blue Haven offers exceptional amenities nearby.",
      "page_copy": "Blue Haven presents an ideal residential choice for those seeking apartments close to the Airport Maintenance Department in Tampa. Situated in the charming Hyde Park neighborhood, our apartments offer easy access to the department, perfect for professionals working nearby.\n\nAt Blue Haven, comfort is never compromised. Delight in the luxury of a garden tub and enjoy social gatherings at our picnic area. Fitness enthusiasts can maintain their routines with available free weights, while our no breed restrictions policy ensures pets stay at home with you. Plus, a one-car garage enhances convenience, making Blue Haven an excellent option for those desiring proximity to the Tampa airport's maintenance facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Airport Maintenance",
      "seo_description": "Find Blue Haven apartments near Tampa airport's maintenance department. Enjoy top amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167728",
      "source": "generator",
      "page_item_url": "apartments-near-hattricks-hyde-park-blue-haven",
      "search_query": "apartments near hattricks hyde park",
      "category": "Transit",
      "h1_title": "Apartments Near Hattricks in Hyde Park",
      "h2_subtitle": "Explore vibrant living with apartments near Hattricks in Hyde Park. Experience the charm of Blue Haven's premier location and amenities.",
      "page_copy": "Located in the lively Hyde Park area, Blue Haven offers an exceptional living experience just steps away from Hattricks, one of Tampa's most popular spots. Whether you're a local or new to the city, this location provides the perfect balance of entertainment and comfort.\n\nBlue Haven is designed with your lifestyle in mind. Unwind in the garden tub or enjoy an outdoor meal in our picnic area. Our facilities include free weights for fitness enthusiasts, and our no breed restrictions policy welcomes all pets. With the added convenience of a one-car garage, Blue Haven stands out as a premier choice for apartments near Hattricks in Hyde Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
      "featured_image_media": {
        "alt_text": "Two cabanas with sheer curtains next to a pool with ocean view",
        "public_id": "01a03539-a0b0-7106-b319-41f0e713bab8",
        "storage_key": "property/6767906449167728/01a03539-a0b0-7106-b319-41f0e713bab8.webp",
        "width": 1920,
        "height": 2880
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hattricks in Hyde Park",
      "seo_description": "Discover Blue Haven apartments close to Hattricks in Hyde Park. Enjoy top-notch amenities in a vibrant, convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IitrNjcvbzFMczZvNGdFTmRWSmhvVkE9PSIsInZhbHVlIjoic1oyRmNlRFFmc3FRbnBMYUZ1bE9lQT09IiwibWFjIjoiYzczNjBkMjRkM2FjMWU4NzgzYmQxOTA1NTU4MzVhOGJkOGU5YzA1ODZhYzE3ZjQ5YjZlYzRjMjAxZjY0NmQ0NyJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6IitrNjcvbzFMczZvNGdFTmRWSmhvVkE9PSIsInZhbHVlIjoic1oyRmNlRFFmc3FRbnBMYUZ1bE9lQT09IiwibWFjIjoiYzczNjBkMjRkM2FjMWU4NzgzYmQxOTA1NTU4MzVhOGJkOGU5YzA1ODZhYzE3ZjQ5YjZlYzRjMjAxZjY0NmQ0NyJ9",
  "custom_audioeye_site_id": "164ed051-0f03-41a5-9e4f-95d9b55c0311",
  "custom_audioeye_site_hash": "26092a3c3d6bdf8e21911d1db43c5f58"
};

export const generatedAt = '2026-09-11T19:12:59.017Z';
